// Auto-completed UI translations for previously missing admin-client copy.
// Keep keys in Korean so existing t('...') calls remain stable.
const keys = [
  "* 배경 이미지는 최대 5MB까지 업로드 가능합니다. 기존 URL 직접 입력 방식도 유지됩니다.",
  "* 이 항목의 배경은 선택한 디바이스/언어 타겟에만 적용됩니다. 국가값은 현재 사용하지 않으므로 저장 시 ALL로 고정됩니다. desktop/mobile 또는 언어별로 다르게 쓰려면 각 타겟 항목을 따로 생성해서 배경을 저장하세요.",
  "/events/avatar-reward 또는 https://...",
  "8자 이상 입력",
  "BB 단위 cap입니다. 0이면 cap 없음.",
  "Event Fee %는 0~100 사이 숫자여야 합니다.",
  "Rake %는 0~100 사이 숫자여야 합니다.",
  "Rake Cap BB는 0 이상의 숫자여야 합니다.",
  "Redis 이메일 큐",
  "SMTP 실패 재시도",
  "[선택]",
  "[필수]",
  "all / 데스크톱+모바일",
  "all / 전체 언어",
  "desktop / 데스크톱",
  "ko / 한국어",
  "lv2 에이전트 계정에만",
  "lv2 추천 보상 포인트",
  "mobile / 모바일",
  "{amount} USDT 전액 자산으로 변환",
  "{amount} USDT 포인트 전액을 현재 에이전트 자산으로 변환할까요?",
  "가 적립됩니다. 한 유저는 한 번만 스탬프 처리됩니다.",
  "가입 유저가 없습니다.",
  "가입 현황을 불러오지 못했습니다.",
  "가입 후 승인 상태를 확인할 수 있습니다.",
  "가입일",
  "각 칸은 별도 인포 버튼 항목입니다. 없으면 현재 설정을 복제해서 생성하고, 있으면 해당 항목을 열어 배경 이미지를 따로 바꿀 수 있습니다.",
  "개별 발송 가능",
  "개별 발송 결과를 불러오는 중...",
  "개별 발송 기록이 없습니다.",
  "개별 발송 이력을 불러오지 못했습니다.",
  "개인정보 수집 및 이용 동의",
  "개인정보 수집 및 이용 안내",
  "개인정보 안내",
  "검색 결과가 없습니다.",
  "검색 중",
  "계정 문제는 상위 관리자에게 문의",
  "계정 상태와 접근 권한을 확인합니다.",
  "계정 유형과 필수 정보를 확인한 뒤 생성해 주세요. 생성된 계정은 즉시 현재 에이전트 아래에 연결됩니다.",
  "계정 입력",
  "계정 확인 및 복구에 사용됩니다.",
  "계정과 복구 정보를 정확히 입력합니다.",
  "계정은 본인 또는 정당한 권한을 가진 사용자가 생성해야 하며, 계정 공유·권한 오용·서비스 운영 방해 행위는 제한될 수 있습니다.",
  "공용 기기에서는 로그인 상태 유지를 선택하지 마세요.",
  "관리 도구 접속",
  "관리 서비스를 위한",
  "관리 화면에 표시되는 이름입니다.",
  "관리자 계정 정보를 입력해 주세요.",
  "관리자 로그인 안내",
  "관리자 메뉴",
  "관리자 메뉴 열기",
  "관리자 승인",
  "관리자 승인이 완료된 계정만 접속할 수 있습니다.",
  "관리자 승인이 필요한 계정은 승인 완료 후 로그인할 수 있습니다.",
  "관리자 아이디 입력",
  "관리자 전용 로그인",
  "관리자 홈",
  "권한 확인",
  "기존",
  "기존 타겟 항목 열기",
  "내 계정",
  "내부 팝업 URL",
  "노출 타겟 / 개별 배경 기준",
  "누적 획득 포인트",
  "닉네임은 2~16자로 입력해 주세요.",
  "다음 20 USDT까지",
  "다음 보상 대기 유저",
  "대기",
  "대기열",
  "대기열 등록 중...",
  "대상",
  "대소문자를 구분하여 정확하게 입력해 주세요.",
  "데스크톱",
  "동일한 비밀번호를 입력해 주세요.",
  "등록 이메일 없음",
  "디바이스",
  "디바이스/언어별 배경 빠른 관리",
  "로그인 및 주요 관리 활동은 보안을 위해 기록됩니다.",
  "로그인 아이디 저장",
  "로그인 중…",
  "로그인 화면으로 돌아가기",
  "로그인 화면으로 이동",
  "로그인에 사용할 아이디입니다.",
  "로그인이 반복해서 실패하면 계정이 일시적으로 잠길 수 있습니다. 관리자에게 계정 상태를 확인해 주세요.",
  "를 입력하세요.",
  "링크 복사",
  "마케팅 수신 동의",
  "마케팅 수신 동의 유저 {count}명",
  "마케팅 이메일 수신 동의 대상자가 없습니다.",
  "메일 작성",
  "메일 제목",
  "메일 제목과 본문을 입력해 주세요.",
  "명마다",
  "모바일",
  "미생성",
  "미션 상금 수혜자 설정",
  "미인증",
  "받은편지함에 표시될 제목",
  "발급받은 관리자 계정 아이디를 입력해 주세요.",
  "발급받은 관리자 아이디를 입력합니다.",
  "발송 대상",
  "발송 미리보기",
  "발송 이력",
  "발송할 내용을 입력하세요.",
  "발송할 유저를 선택해 주세요.",
  "배경 없음",
  "배경 이미지 업로드 / URL",
  "배경 이미지 업로드 실패 (서버 업로드 API 확인 필요)",
  "배경 이미지 파일은 5MB 이하로 올려주세요.",
  "배치",
  "버튼 URL",
  "버튼 문구",
  "변환",
  "변환 중...",
  "변환 후 자산",
  "보기",
  "보안 안내",
  "보유 기간",
  "보호됨",
  "본 메일은 Night Poker Club에서 발송되었습니다.",
  "본문 제목",
  "분배식",
  "분배식은 agent_id:percent 형식이며 percent 합계는 1 또는 100이어야 합니다. 예: 1002:0.7 / 1001:0.3",
  "비밀번호 다시 입력",
  "비밀번호 입력",
  "비밀번호 확인",
  "비밀번호 확인 값이 일치하지 않습니다.",
  "비밀번호는 8자 이상 입력해 주세요.",
  "비밀번호는 다른 서비스와 다르게 설정해 주세요.",
  "비워두면 메일 제목 사용",
  "사용 가능 포인트",
  "사용 가능한 이메일 주소를 입력해 주세요.",
  "상금 수혜자",
  "상위 에이전트: {id}",
  "상위 에이전트가 전부 수령",
  "새 계정을 생성합니다.",
  "서비스 이용에 필요한 기본 정보를 입력해 주세요.",
  "선택",
  "성공",
  "소속 에이전트",
  "수신 동의",
  "수신 미동의",
  "수신자",
  "수집 항목",
  "수혜 방식",
  "수혜자 agent_id",
  "수혜자 agent_id를 입력하세요.",
  "수혜자 설정 저장 실패",
  "슈퍼어드민 전용 · 이메일 워커 대기열 발송",
  "스탬프",
  "스탬프 완료",
  "스탬프 완료 유저",
  "승인 계정 확인",
  "승인된 관리자 계정 전용",
  "승인된 관리자 계정으로 로그인한 뒤 운영 대시보드와 관리 기능을 이용해 주세요.",
  "승인된 범위의 운영 기능을 이용합니다.",
  "시도",
  "실제 워커 템플릿 기준",
  "아래 링크를 복사해 주세요.",
  "아바타 보상 이벤트 팝업 URL 적용",
  "아바타 보상 이벤트 팝업을 열려면 이동 URL에",
  "아이디",
  "아이디, 닉네임, 비밀번호는 필수입니다. 2차 비밀번호는 필요한 경우에만 입력합니다.",
  "아이디, 닉네임, 이메일, 비밀번호",
  "아이디는 영문, 숫자, 밑줄을 사용해 4~20자로 입력해 주세요.",
  "아직 계정이 없으신가요?",
  "아직 발송 이력이 없습니다.",
  "아직 변환 기록이 없습니다.",
  "아직 적립 기록이 없습니다.",
  "안전한 관리 서비스",
  "약관 동의",
  "에게 발송합니다.",
  "에이전트 가입 현황",
  "에이전트 계층과 소속 유저, 수수료, 자산 및 미션 상금 정책을 관리합니다.",
  "에이전트 목록을 불러오지 못했습니다.",
  "에이전트 추가 상금 미지급",
  "에이전트 코드",
  "여러 에이전트 분배 수령",
  "영문, 숫자, 특수문자 조합을 권장합니다.",
  "영문·숫자 4~20자",
  "예: 사이트 바로가기",
  "예상 발송",
  "오늘 조직 가입자",
  "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
  "우선순위",
  "유저 검색",
  "유저 검색에 실패했습니다.",
  "유저 코드",
  "유저 코드, 아이디, 닉네임",
  "유저 코드, 아이디, 닉네임, 소속 에이전트 검색",
  "이 설정은 유저 테이블 상금은 건드리지 않고, agent_share로 계산된 추가 상금의 수혜자만 결정합니다.",
  "이메일",
  "이메일 관리 정보를 불러오는 중...",
  "이메일 관리 정보를 불러오지 못했습니다.",
  "이메일 마케팅 정보 수신",
  "이메일 발송",
  "이메일 발송 요청에 실패했습니다.",
  "이메일 제목 미리보기",
  "이메일을 발송할까요?\n\n대상: {target}\n제목: {subject}\n예상 발송: {count}건",
  "이메일이 발송 대기열에 등록되었습니다.",
  "이미 계정이 있으신가요?",
  "이미 등록된 이메일입니다.",
  "이미 사용 중인 아이디입니다.",
  "이용 목적",
  "이용 약관 동의",
  "이용약관 동의",
  "이용약관과 개인정보 수집 및 이용에 동의해 주세요.",
  "인증 이메일 보유",
  "인증된 이메일이 없는 유저에게는 발송할 수 없습니다.",
  "인증된 이메일이 있고, 마케팅 이메일 수신에 동의했으며, 차단되지 않은 유저",
  "인증됨",
  "일시",
  "입력한 정보는 계정 생성, 승인, 본인 확인 및 계정 복구 목적으로만 처리됩니다. 탈퇴 또는 보유 목적 달성 후 관계 법령에 따른 보관 기간을 제외하고 파기됩니다.",
  "자기 직속 유저와 모든 하위 에이전트 소속 유저를 합산해 확인합니다.",
  "자산 변환 완료",
  "작성한 이메일 본문이 여기에 표시됩니다.",
  "재시도 대기",
  "적립",
  "적립됩니다.",
  "전용 회원가입 URL",
  "전체 동의",
  "전체 발송 대상",
  "접속 기록 보호",
  "접속을 시작합니다.",
  "정보 입력",
  "조직 전체",
  "조직 전체 가입자",
  "조회할 에이전트",
  "직속",
  "직속 가입자",
  "직속 에이전트가 전부 수령",
  "처리 시각 / 오류",
  "최근 30일",
  "최근 7일",
  "최근 자산 변환",
  "최근 포인트 적립",
  "최상위 에이전트가 전부 수령",
  "추천 유저 보상 포인트는 각 조직의",
  "추천 코드",
  "추천 코드 또는 에이전트 라인 코드",
  "추천 코드를 확인할 수 없습니다.",
  "타겟별 인포 버튼 생성 실패",
  "테스트 수신 이메일",
  "테스트 수신 이메일을 입력해 주세요.",
  "테이블 그룹 정산 정책",
  "테이블 그룹 정산 정책 저장 실패",
  "특정 에이전트가 전부 수령",
  "포인트 스탬프",
  "포인트 자산 변환에 실패했습니다.",
  "포인트 현황은 조회할 수 있지만 자산 변환은 해당 lv2 에이전트 본인만 실행할 수 있습니다.",
  "포인트가 자산으로 변환되었습니다.",
  "표시할 닉네임",
  "필수 개인정보 수집에 동의하지 않으면 회원가입이 제한됩니다.",
  "필수 및 선택 항목에 모두 동의합니다.",
  "필수 약관과 개인정보 안내를 확인합니다.",
  "필수 정보를 입력하고 개인정보 수집 및 이용 안내를 확인한 뒤 가입을 완료해 주세요.",
  "필수 확인",
  "하단 안내",
  "하부",
  "하부 가입자",
  "하부 조직 유저",
  "하위 에이전트 또는 일반 유저 계정을 생성합니다. 입력한 계정 정보는 생성 즉시 적용됩니다.",
  "한 줄에 agent_id:percent 입력. percent 합계는 1 또는 100이어야 합니다.",
  "항목을 누르면 개별 발송 결과를 확인할 수 있습니다.",
  "현재 발송 대기",
  "현재 사용할 수 없는 추천 코드입니다.",
  "현재 설정으로 타겟 항목 생성",
  "현재 에이전트 아래에 일반 유저를 생성합니다.",
  "현재 편집:",
  "현재 회원가입이 중지되어 있습니다.",
  "활성",
  "회원 식별, 계정 관리, 본인 확인 및 계정 복구",
  "회원 식별과 계정 관리·복구를 위해 아이디, 닉네임, 이메일 및 인증 정보를 처리하며, 이용 목적 달성 후 관련 법령에 따라 보관 또는 파기합니다.",
  "회원 탈퇴 시까지 또는 관계 법령에서 정한 기간",
  "회원가입",
  "회원가입 API를 찾지 못했습니다.",
  "회원가입 링크가 복사되었습니다.",
  "회원가입 및 계정 관리를 위해 아래 개인정보를 수집합니다. 내용을 확인한 후 가입을 진행해 주세요.",
  "회원가입 안내",
  "회원가입 요청을 처리하지 못했습니다.",
  "회원가입 요청이 거절되었습니다.",
  "회원가입이 완료되었습니다. 바로 로그인할 수 있습니다.",
  "회원가입 요청이 완료되었습니다. 승인된 계정은 바로 로그인할 수 있습니다.",
  "회원가입 처리 중…"
];

const enValues = [
  "* Background images can be uploaded up to 5 MB. Direct URL entry is also supported.",
  "* This background applies only to the selected device/language target. Country is currently unused and is saved as ALL. Create a separate target item for each desktop/mobile or language-specific background.",
  "/events/avatar-reward or https://...",
  "Enter at least 8 characters",
  "Cap in BB units. Enter 0 for no cap.",
  "Event Fee % must be between 0 and 100.",
  "Rake % must be between 0 and 100.",
  "Rake Cap BB must be 0 or greater.",
  "Redis Email Queue",
  "Retry SMTP Failures",
  "[Optional]",
  "[Required]",
  "all / Desktop + Mobile",
  "all / All Languages",
  "desktop / Desktop",
  "ko / Korean",
  "Only to the lv2 agent account",
  "lv2 Referral Reward Points",
  "mobile / Mobile",
  "Convert all {amount} USDT to assets",
  "Convert all {amount} USDT points to the current agent's assets?",
  "will be credited. Each user is stamped only once.",
  "No registered users.",
  "Failed to load registration status.",
  "You can check the approval status after registration.",
  "Registration Date",
  "Each cell is a separate info-button item. If none exists, it is created by copying the current settings; if it exists, open it to change its background separately.",
  "Individual Sending Available",
  "Loading individual delivery results...",
  "No individual delivery records.",
  "Failed to load individual delivery history.",
  "Consent to Collection and Use of Personal Information",
  "Personal Information Collection and Use Notice",
  "Privacy Notice",
  "No search results.",
  "Searching",
  "Contact your senior administrator for account issues",
  "Check the account status and access permissions.",
  "Check the account type and required information before creating it. The new account is immediately linked under the current agent.",
  "Account Information",
  "Used for account verification and recovery.",
  "Enter account and recovery information accurately.",
  "Accounts must be created by the owner or an authorized person. Account sharing, permission misuse, and disruption of service operations may be restricted.",
  "Do not select Keep me signed in on a shared device.",
  "Access Admin Tools",
  "For administration services",
  "This name is displayed in the admin interface.",
  "Enter the administrator account information.",
  "Administrator Login Notice",
  "Admin Menu",
  "Open Admin Menu",
  "Administrator Approval",
  "Only accounts approved by an administrator can access this service.",
  "Accounts requiring administrator approval can sign in after approval is completed.",
  "Enter Admin ID",
  "Administrator Login",
  "Admin Home",
  "Permission Check",
  "Existing",
  "Open Existing Target Item",
  "My Account",
  "Internal Popup URL",
  "Exposure Target / Individual Background",
  "Total Points Earned",
  "Enter a nickname between 2 and 16 characters.",
  "Until the next 20 USDT",
  "Users Waiting for Next Reward",
  "Pending",
  "Queue",
  "Adding to queue...",
  "Target",
  "Enter it exactly, including letter case.",
  "Desktop",
  "Enter the same password.",
  "No Registered Email",
  "Device",
  "Quick Background Management by Device/Language",
  "Sign-ins and major administrative activities are logged for security.",
  "Remember Login ID",
  "Signing in…",
  "Back to Login",
  "Go to Login",
  "This is the ID used to sign in.",
  "Repeated failed sign-in attempts may temporarily lock the account. Ask an administrator to check the account status.",
  "Enter",
  "Copy Link",
  "Marketing Consent",
  "{count} users with marketing consent",
  "There are no users who consented to marketing emails.",
  "Compose Email",
  "Email Subject",
  "Enter the email subject and body.",
  "users each",
  "Mobile",
  "Not Created",
  "Mission Prize Beneficiary Settings",
  "Unverified",
  "Subject shown in the inbox",
  "Enter the issued administrator account ID.",
  "Enter the issued administrator ID.",
  "Recipients",
  "Delivery Preview",
  "Delivery History",
  "Enter the content to send.",
  "Select a user to send to.",
  "No Background",
  "Upload Background Image / URL",
  "Background image upload failed (check the server upload API)",
  "Upload a background image of 5 MB or less.",
  "Batch",
  "Button URL",
  "Button Label",
  "Convert",
  "Converting...",
  "Assets After Conversion",
  "View",
  "Security Notice",
  "Retention Period",
  "Protected",
  "This email was sent by Night Poker Club.",
  "Body Title",
  "Distribution Formula",
  "The distribution formula must use agent_id:percent, and the percentages must total 1 or 100. Example: 1002:0.7 / 1001:0.3",
  "Re-enter Password",
  "Enter Password",
  "Confirm Password",
  "The password confirmation does not match.",
  "Enter a password of at least 8 characters.",
  "Use a password different from other services.",
  "Leave blank to use the email subject",
  "Available Points",
  "Enter a valid email address.",
  "Prize Beneficiary",
  "Parent Agent: {id}",
  "Parent agent receives all",
  "Create a new account.",
  "Enter the basic information required to use the service.",
  "Select",
  "Success",
  "Assigned Agent",
  "Consented",
  "Not Consented",
  "Recipient",
  "Collected Information",
  "Beneficiary Method",
  "Beneficiary agent_id",
  "Enter the beneficiary agent_id.",
  "Failed to save beneficiary settings",
  "Superadmin only · Send through email worker queue",
  "Stamp",
  "Stamped",
  "Stamped Users",
  "Verify Approved Account",
  "Approved Administrator Accounts Only",
  "Sign in with an approved administrator account to use the operations dashboard and management features.",
  "Use operational features within the approved scope.",
  "Attempt",
  "Based on the actual worker template",
  "Copy the link below.",
  "Apply Avatar Reward Event Popup URL",
  "To open the avatar reward event popup, enter this in the destination URL:",
  "ID",
  "ID, nickname, and password are required. Enter a secondary password only when needed.",
  "ID, nickname, email, and password",
  "Enter 4–20 characters using letters, numbers, and underscores.",
  "Don't have an account yet?",
  "No delivery history yet.",
  "No conversion history yet.",
  "No accrual history yet.",
  "Secure Administration Service",
  "Terms Consent",
  "will receive this message.",
  "Agent Registration Status",
  "Manage agent hierarchy, assigned users, fees, assets, and mission prize policies.",
  "Failed to load the agent list.",
  "Do Not Pay Additional Agent Prize",
  "Agent Code",
  "Distribute Among Multiple Agents",
  "A combination of letters, numbers, and special characters is recommended.",
  "4–20 letters and numbers",
  "Example: Visit Website",
  "Estimated Sends",
  "Organization Registrations Today",
  "Too many requests. Please try again later.",
  "Priority",
  "User Search",
  "User search failed.",
  "User Code",
  "User code, ID, nickname",
  "Search user code, ID, nickname, or assigned agent",
  "This setting does not affect user table prizes; it only determines the beneficiaries of the additional prize calculated from agent_share.",
  "Email",
  "Loading email management information...",
  "Failed to load email management information.",
  "Receive Email Marketing Information",
  "Send Email",
  "Email sending request failed.",
  "Email Subject Preview",
  "Send this email?\n\nTarget: {target}\nSubject: {subject}\nEstimated sends: {count}",
  "The email was added to the sending queue.",
  "Already have an account?",
  "This email is already registered.",
  "This ID is already in use.",
  "Purpose of Use",
  "Agree to Terms of Service",
  "Terms of Service Consent",
  "Agree to the Terms of Service and the collection and use of personal information.",
  "Has Verified Email",
  "Cannot send to a user without a verified email address.",
  "Users who have a verified email, consented to marketing email, and are not blocked",
  "Verified",
  "Date and Time",
  "The information entered is processed only for account creation, approval, identity verification, and account recovery. It is deleted after withdrawal or fulfillment of the retention purpose, except for periods required by law.",
  "View the combined total of your direct users and users assigned to all downstream agents.",
  "Asset Conversion Complete",
  "The email body you write will appear here.",
  "Waiting to Retry",
  "Accrual",
  "will be credited.",
  "Dedicated Registration URL",
  "Agree to All",
  "All Delivery Targets",
  "Access Log Protection",
  "Start access.",
  "Enter Information",
  "Entire Organization",
  "Total Organization Registrations",
  "Agent to View",
  "Direct",
  "Direct Registrations",
  "Direct agent receives all",
  "Processed At / Error",
  "Last 30 Days",
  "Last 7 Days",
  "Recent Asset Conversions",
  "Recent Point Accruals",
  "Top-level agent receives all",
  "Referral user reward points for each organization are credited",
  "Referral Code",
  "Referral code or agent line code",
  "Unable to verify the referral code.",
  "Failed to create info button for target",
  "Test Recipient Email",
  "Enter the test recipient email.",
  "Table Group Settlement Policy",
  "Failed to save table group settlement policy",
  "Specified agent receives all",
  "Point Stamp",
  "Point-to-asset conversion failed.",
  "Point status can be viewed, but only the lv2 agent can convert points to assets.",
  "Points were converted to assets.",
  "Display Nickname",
  "Registration is restricted unless you consent to the required collection of personal information.",
  "Agree to all required and optional items.",
  "Review the required terms and privacy notice.",
  "Enter the required information, review the personal information collection and use notice, and complete registration.",
  "Required Confirmation",
  "Footer Notice",
  "Downline",
  "Downline Registrations",
  "Downline Organization Users",
  "Create a child agent or regular user account. The entered account information takes effect immediately after creation.",
  "Enter one agent_id:percent per line. The percentages must total 1 or 100.",
  "Select an item to view individual delivery results.",
  "Currently Waiting to Send",
  "This referral code is currently unavailable.",
  "Create Target Item from Current Settings",
  "Create a regular user under the current agent.",
  "Currently Editing:",
  "Registration is currently suspended.",
  "Active",
  "Member identification, account management, identity verification, and account recovery",
  "For member identification and account management/recovery, we process ID, nickname, email, and verification information, then retain or delete it according to applicable law after the purpose is fulfilled.",
  "Until account withdrawal or the period required by law",
  "Register",
  "Registration API not found.",
  "Registration link copied.",
  "We collect the personal information below for registration and account management. Review it before continuing.",
  "Registration Notice",
  "Unable to process the registration request.",
  "The registration request was rejected.",
  "Registration is complete. You can sign in immediately.",
  "The registration request has been completed. Approved accounts can sign in immediately.",
  "Processing registration…"
];

const ruValues = [
  "* Фоновое изображение должно быть не больше 5 МБ. Также можно напрямую указать URL.",
  "* Этот фон применяется только к выбранной цели устройства/языка. Страна сейчас не используется и при сохранении фиксируется как ALL. Для разных фонов desktop/mobile или языков создавайте отдельные целевые элементы.",
  "/events/avatar-reward или https://...",
  "Введите не менее 8 символов",
  "Лимит в единицах BB. 0 означает отсутствие лимита.",
  "Event Fee % должен быть числом от 0 до 100.",
  "Rake % должен быть числом от 0 до 100.",
  "Rake Cap BB должен быть числом не меньше 0.",
  "Очередь писем Redis",
  "Повторить ошибки SMTP",
  "[Необязательно]",
  "[Обязательно]",
  "all / ПК + мобильные",
  "all / Все языки",
  "desktop / ПК",
  "ko / Корейский",
  "Только на аккаунт агента lv2",
  "Баллы за рефералов lv2",
  "mobile / Мобильные",
  "Преобразовать все {amount} USDT в активы",
  "Преобразовать все {amount} USDT-баллов в активы текущего агента?",
  "будет начислено. Каждый пользователь отмечается только один раз.",
  "Зарегистрированных пользователей нет.",
  "Не удалось загрузить статус регистрации.",
  "После регистрации можно проверить статус одобрения.",
  "Дата регистрации",
  "Каждая ячейка — отдельный элемент информационной кнопки. Если его нет, он создаётся копированием текущих настроек; если есть, откройте его, чтобы отдельно изменить фон.",
  "Доступна индивидуальная отправка",
  "Загрузка результатов индивидуальной отправки...",
  "Записей индивидуальной отправки нет.",
  "Не удалось загрузить историю индивидуальных отправок.",
  "Согласие на сбор и использование персональных данных",
  "Уведомление о сборе и использовании персональных данных",
  "Уведомление о конфиденциальности",
  "Результатов поиска нет.",
  "Поиск",
  "По вопросам аккаунта обратитесь к старшему администратору",
  "Проверьте статус аккаунта и права доступа.",
  "Перед созданием проверьте тип аккаунта и обязательные данные. Новый аккаунт сразу привязывается к текущему агенту.",
  "Данные аккаунта",
  "Используется для проверки и восстановления аккаунта.",
  "Введите данные аккаунта и восстановления точно.",
  "Аккаунт должен создавать владелец или уполномоченное лицо. Совместное использование, злоупотребление правами и вмешательство в работу сервиса могут быть ограничены.",
  "Не выбирайте сохранение входа на общем устройстве.",
  "Открыть инструменты управления",
  "Для административного сервиса",
  "Это имя отображается в панели управления.",
  "Введите данные аккаунта администратора.",
  "Сведения о входе администратора",
  "Меню администратора",
  "Открыть меню администратора",
  "Одобрение администратором",
  "Доступ разрешён только аккаунтам, одобренным администратором.",
  "Аккаунты, требующие одобрения, смогут войти после его завершения.",
  "Введите ID администратора",
  "Вход для администратора",
  "Главная администратора",
  "Проверка прав",
  "Существующий",
  "Открыть существующий целевой элемент",
  "Мой аккаунт",
  "URL внутреннего окна",
  "Цель показа / отдельный фон",
  "Всего заработано баллов",
  "Введите никнейм длиной 2–16 символов.",
  "До следующих 20 USDT",
  "Пользователи в ожидании следующей награды",
  "Ожидание",
  "Очередь",
  "Добавление в очередь...",
  "Цель",
  "Введите точно с учётом регистра.",
  "ПК",
  "Введите тот же пароль.",
  "Нет зарегистрированного email",
  "Устройство",
  "Быстрое управление фоном по устройству/языку",
  "В целях безопасности входы и основные действия администратора записываются.",
  "Запомнить ID входа",
  "Вход…",
  "Вернуться к входу",
  "Перейти к входу",
  "Это ID, используемый для входа.",
  "Повторные неудачные попытки входа могут временно заблокировать аккаунт. Уточните статус у администратора.",
  "Введите",
  "Копировать ссылку",
  "Согласие на маркетинг",
  "Пользователей с согласием на маркетинг: {count}",
  "Нет пользователей, согласившихся на маркетинговые письма.",
  "Создать письмо",
  "Тема письма",
  "Введите тему и текст письма.",
  "пользователей на",
  "Мобильные",
  "Не создано",
  "Настройки получателя приза миссии",
  "Не подтверждено",
  "Тема, отображаемая во входящих",
  "Введите выданный ID аккаунта администратора.",
  "Введите выданный ID администратора.",
  "Получатели",
  "Предпросмотр отправки",
  "История отправок",
  "Введите содержимое для отправки.",
  "Выберите пользователя для отправки.",
  "Без фона",
  "Загрузка фонового изображения / URL",
  "Не удалось загрузить фон (проверьте API загрузки сервера)",
  "Загрузите фоновое изображение не больше 5 МБ.",
  "Пакет",
  "URL кнопки",
  "Текст кнопки",
  "Преобразовать",
  "Преобразование...",
  "Активы после преобразования",
  "Просмотр",
  "Уведомление о безопасности",
  "Срок хранения",
  "Защищено",
  "Это письмо отправлено Night Poker Club.",
  "Заголовок текста",
  "Формула распределения",
  "Формула должна иметь вид agent_id:percent, а сумма процентов — 1 или 100. Пример: 1002:0.7 / 1001:0.3",
  "Повторите пароль",
  "Введите пароль",
  "Подтвердите пароль",
  "Подтверждение пароля не совпадает.",
  "Введите пароль длиной не менее 8 символов.",
  "Используйте пароль, отличный от других сервисов.",
  "Оставьте пустым, чтобы использовать тему письма",
  "Доступные баллы",
  "Введите действительный адрес email.",
  "Получатель приза",
  "Вышестоящий агент: {id}",
  "Весь приз получает вышестоящий агент",
  "Создать новый аккаунт.",
  "Введите основные данные для использования сервиса.",
  "Выбрать",
  "Успешно",
  "Назначенный агент",
  "Согласие дано",
  "Согласие не дано",
  "Получатель",
  "Собираемые данные",
  "Способ назначения получателя",
  "agent_id получателя",
  "Введите agent_id получателя.",
  "Не удалось сохранить настройки получателя",
  "Только для суперадминистратора · Отправка через очередь почтового воркера",
  "Отметка",
  "Отмечено",
  "Отмеченные пользователи",
  "Проверить одобренный аккаунт",
  "Только для одобренных аккаунтов администратора",
  "Войдите с одобренным аккаунтом администратора для доступа к операционной панели и функциям управления.",
  "Используйте функции управления в пределах одобренных прав.",
  "Попытка",
  "На основе фактического шаблона воркера",
  "Скопируйте ссылку ниже.",
  "Применить URL окна события награды за аватар",
  "Чтобы открыть окно события награды за аватар, укажите в URL перехода:",
  "ID",
  "ID, никнейм и пароль обязательны. Вторичный пароль вводите только при необходимости.",
  "ID, никнейм, email, пароль",
  "Введите 4–20 символов: латинские буквы, цифры и подчёркивание.",
  "Ещё нет аккаунта?",
  "Истории отправок пока нет.",
  "Истории преобразований пока нет.",
  "Истории начислений пока нет.",
  "Безопасный административный сервис",
  "Согласие с условиями",
  "получит это сообщение.",
  "Статус регистрации агента",
  "Управление иерархией агентов, пользователями, комиссиями, активами и политикой призов миссий.",
  "Не удалось загрузить список агентов.",
  "Не выплачивать дополнительный приз агенту",
  "Код агента",
  "Распределить между несколькими агентами",
  "Рекомендуется сочетание букв, цифр и специальных символов.",
  "4–20 букв и цифр",
  "Пример: перейти на сайт",
  "Ожидаемое количество отправок",
  "Регистрации организации сегодня",
  "Слишком много запросов. Повторите попытку позже.",
  "Приоритет",
  "Поиск пользователя",
  "Не удалось найти пользователя.",
  "Код пользователя",
  "Код пользователя, ID, никнейм",
  "Поиск по коду пользователя, ID, никнейму или агенту",
  "Эта настройка не изменяет призы пользовательского стола, а только определяет получателей дополнительного приза, рассчитанного по agent_share.",
  "Email",
  "Загрузка данных управления email...",
  "Не удалось загрузить данные управления email.",
  "Получать маркетинговую информацию по email",
  "Отправить email",
  "Не удалось отправить запрос на рассылку.",
  "Предпросмотр темы письма",
  "Отправить это письмо?\n\nЦель: {target}\nТема: {subject}\nОжидается отправок: {count}",
  "Письмо добавлено в очередь отправки.",
  "Уже есть аккаунт?",
  "Этот email уже зарегистрирован.",
  "Этот ID уже используется.",
  "Цель использования",
  "Согласие с условиями сервиса",
  "Согласие с условиями использования",
  "Примите условия сервиса и согласие на сбор и использование персональных данных.",
  "Есть подтверждённый email",
  "Нельзя отправить пользователю без подтверждённого email.",
  "Пользователи с подтверждённым email, согласившиеся на маркетинг и не заблокированные",
  "Подтверждено",
  "Дата и время",
  "Введённые данные обрабатываются только для создания и одобрения аккаунта, проверки личности и восстановления. После удаления аккаунта или достижения цели хранения они уничтожаются, кроме сроков, установленных законом.",
  "Показать общую сумму прямых пользователей и пользователей всех нижестоящих агентов.",
  "Преобразование активов завершено",
  "Текст письма будет показан здесь.",
  "Ожидание повтора",
  "Начисление",
  "будет начислено.",
  "Персональная ссылка регистрации",
  "Согласиться со всем",
  "Все получатели",
  "Защита журнала доступа",
  "Начать доступ.",
  "Ввод данных",
  "Вся организация",
  "Всего регистраций в организации",
  "Агент для просмотра",
  "Прямые",
  "Прямые регистрации",
  "Весь приз получает прямой агент",
  "Время обработки / Ошибка",
  "Последние 30 дней",
  "Последние 7 дней",
  "Недавние преобразования активов",
  "Недавние начисления баллов",
  "Весь приз получает агент верхнего уровня",
  "Баллы за приглашённых пользователей в каждой организации начисляются",
  "Реферальный код",
  "Реферальный код или код линии агента",
  "Не удалось проверить реферальный код.",
  "Не удалось создать информационную кнопку для цели",
  "Тестовый email получателя",
  "Введите тестовый email получателя.",
  "Политика расчётов группы столов",
  "Не удалось сохранить политику расчётов группы столов",
  "Весь приз получает указанный агент",
  "Отметка баллов",
  "Не удалось преобразовать баллы в активы.",
  "Статус баллов можно просматривать, но преобразование в активы может выполнить только соответствующий агент lv2.",
  "Баллы преобразованы в активы.",
  "Отображаемый никнейм",
  "Регистрация недоступна без согласия на обязательный сбор персональных данных.",
  "Согласиться со всеми обязательными и необязательными пунктами.",
  "Проверьте обязательные условия и уведомление о конфиденциальности.",
  "Введите обязательные данные, ознакомьтесь с уведомлением о сборе и использовании персональных данных и завершите регистрацию.",
  "Обязательное подтверждение",
  "Нижнее уведомление",
  "Нижестоящие",
  "Регистрации нижестоящих",
  "Пользователи нижестоящей организации",
  "Создать нижестоящего агента или обычного пользователя. Введённые данные применяются сразу после создания.",
  "Введите по одной строке agent_id:percent. Сумма процентов должна быть 1 или 100.",
  "Нажмите элемент, чтобы просмотреть результаты индивидуальной отправки.",
  "Сейчас ожидают отправки",
  "Этот реферальный код сейчас недоступен.",
  "Создать целевой элемент из текущих настроек",
  "Создать обычного пользователя под текущим агентом.",
  "Сейчас редактируется:",
  "Регистрация сейчас приостановлена.",
  "Активен",
  "Идентификация участника, управление аккаунтом, проверка личности и восстановление",
  "Для идентификации и управления/восстановления аккаунта мы обрабатываем ID, никнейм, email и данные проверки, затем храним или удаляем их по закону после достижения цели.",
  "До удаления аккаунта или в течение срока, установленного законом",
  "Регистрация",
  "API регистрации не найден.",
  "Ссылка регистрации скопирована.",
  "Для регистрации и управления аккаунтом мы собираем указанные ниже персональные данные. Ознакомьтесь с ними перед продолжением.",
  "Сведения о регистрации",
  "Не удалось обработать запрос регистрации.",
  "Запрос регистрации отклонён.",
  "Регистрация завершена. Вы можете войти сразу.",
  "Запрос регистрации завершён. Одобренные аккаунты могут войти сразу.",
  "Обработка регистрации…"
];

const zhValues = [
  "* 背景图片最大可上传 5MB，同时保留直接输入 URL 的方式。",
  "* 此背景仅应用于所选设备/语言目标。国家值当前未使用，保存时固定为 ALL。若要为 desktop/mobile 或不同语言使用不同背景，请分别创建目标项目并保存背景。",
  "/events/avatar-reward 或 https://...",
  "请输入至少 8 个字符",
  "以 BB 为单位的上限。输入 0 表示无上限。",
  "Event Fee % 必须为 0 到 100 之间的数字。",
  "Rake % 必须为 0 到 100 之间的数字。",
  "Rake Cap BB 必须为大于等于 0 的数字。",
  "Redis 邮件队列",
  "重试 SMTP 失败任务",
  "[可选]",
  "[必填]",
  "all / 桌面端+移动端",
  "all / 全部语言",
  "desktop / 桌面端",
  "ko / 韩语",
  "仅计入 lv2 代理账户",
  "lv2 推荐奖励积分",
  "mobile / 移动端",
  "将全部 {amount} USDT 转换为资产",
  "是否将全部 {amount} USDT 积分转换为当前代理的资产？",
  "将被计入。每位用户只盖章一次。",
  "没有注册用户。",
  "无法加载注册状态。",
  "注册后可查看审批状态。",
  "注册日期",
  "每个单元格都是独立的信息按钮项目。若不存在，将复制当前设置创建；若已存在，可打开该项目单独修改背景图片。",
  "可单独发送",
  "正在加载单独发送结果...",
  "没有单独发送记录。",
  "无法加载单独发送记录。",
  "同意收集和使用个人信息",
  "个人信息收集与使用说明",
  "隐私说明",
  "没有搜索结果。",
  "搜索中",
  "账户问题请联系上级管理员",
  "检查账户状态和访问权限。",
  "请确认账户类型和必填信息后再创建。新账户会立即关联到当前代理名下。",
  "账户信息",
  "用于账户确认和恢复。",
  "请准确输入账户及恢复信息。",
  "账户必须由本人或合法授权人员创建。共享账户、滥用权限或干扰服务运营的行为可能会受到限制。",
  "请勿在公共设备上选择保持登录状态。",
  "进入管理工具",
  "用于管理服务",
  "此名称将显示在管理界面中。",
  "请输入管理员账户信息。",
  "管理员登录说明",
  "管理员菜单",
  "打开管理员菜单",
  "管理员审批",
  "仅管理员已审批的账户可以访问。",
  "需要管理员审批的账户须在审批完成后登录。",
  "输入管理员 ID",
  "管理员专用登录",
  "管理员首页",
  "权限检查",
  "现有",
  "打开现有目标项目",
  "我的账户",
  "内部弹窗 URL",
  "展示目标 / 独立背景标准",
  "累计获得积分",
  "请输入 2 到 16 个字符的昵称。",
  "距离下一个 20 USDT",
  "等待下次奖励的用户",
  "等待中",
  "队列",
  "正在加入队列...",
  "目标",
  "请区分大小写并准确输入。",
  "桌面端",
  "请输入相同的密码。",
  "未登记邮箱",
  "设备",
  "按设备/语言快速管理背景",
  "为确保安全，登录及主要管理活动会被记录。",
  "保存登录 ID",
  "正在登录…",
  "返回登录页面",
  "前往登录页面",
  "这是登录时使用的 ID。",
  "若连续登录失败，账户可能被暂时锁定。请联系管理员确认账户状态。",
  "请输入",
  "复制链接",
  "同意接收营销信息",
  "同意营销的用户 {count} 人",
  "没有同意接收营销邮件的用户。",
  "撰写邮件",
  "邮件主题",
  "请输入邮件主题和正文。",
  "每人",
  "移动端",
  "未创建",
  "任务奖金受益人设置",
  "未验证",
  "收件箱中显示的主题",
  "请输入已签发的管理员账户 ID。",
  "请输入已签发的管理员 ID。",
  "发送对象",
  "发送预览",
  "发送记录",
  "请输入要发送的内容。",
  "请选择要发送的用户。",
  "无背景",
  "上传背景图片 / URL",
  "背景图片上传失败（请检查服务器上传 API）",
  "请上传不超过 5MB 的背景图片。",
  "批次",
  "按钮 URL",
  "按钮文字",
  "转换",
  "转换中...",
  "转换后资产",
  "查看",
  "安全说明",
  "保留期限",
  "受保护",
  "本邮件由 Night Poker Club 发送。",
  "正文标题",
  "分配公式",
  "分配公式必须使用 agent_id:percent 格式，percent 总和必须为 1 或 100。例如：1002:0.7 / 1001:0.3",
  "再次输入密码",
  "输入密码",
  "确认密码",
  "两次输入的密码不一致。",
  "请输入至少 8 个字符的密码。",
  "请设置与其他服务不同的密码。",
  "留空则使用邮件主题",
  "可用积分",
  "请输入有效的邮箱地址。",
  "奖金受益人",
  "上级代理：{id}",
  "由上级代理全部领取",
  "创建新账户。",
  "请输入使用服务所需的基本信息。",
  "选择",
  "成功",
  "所属代理",
  "已同意",
  "未同意",
  "收件人",
  "收集项目",
  "受益方式",
  "受益人 agent_id",
  "请输入受益人 agent_id。",
  "保存受益人设置失败",
  "仅限超级管理员 · 通过邮件工作队列发送",
  "盖章",
  "已盖章",
  "已盖章用户",
  "确认已审批账户",
  "仅限已审批管理员账户",
  "请使用已审批的管理员账户登录，以使用运营仪表板和管理功能。",
  "使用审批范围内的运营功能。",
  "尝试",
  "基于实际工作器模板",
  "请复制下方链接。",
  "应用头像奖励活动弹窗 URL",
  "若要打开头像奖励活动弹窗，请在跳转 URL 中输入：",
  "ID",
  "ID、昵称和密码为必填项。仅在需要时输入二级密码。",
  "ID、昵称、邮箱、密码",
  "请使用英文字母、数字和下划线输入 4 到 20 个字符。",
  "还没有账户吗？",
  "暂无发送记录。",
  "暂无转换记录。",
  "暂无累计记录。",
  "安全管理服务",
  "同意条款",
  "将收到此邮件。",
  "代理注册状态",
  "管理代理层级、所属用户、手续费、资产和任务奖金政策。",
  "无法加载代理列表。",
  "不支付代理追加奖金",
  "代理代码",
  "多个代理分配领取",
  "建议组合使用字母、数字和特殊字符。",
  "4–20 位字母和数字",
  "示例：访问网站",
  "预计发送",
  "今日组织注册人数",
  "请求过多，请稍后重试。",
  "优先级",
  "用户搜索",
  "用户搜索失败。",
  "用户代码",
  "用户代码、ID、昵称",
  "搜索用户代码、ID、昵称或所属代理",
  "此设置不会影响用户牌桌奖金，只决定由 agent_share 计算的追加奖金受益人。",
  "邮箱",
  "正在加载邮件管理信息...",
  "无法加载邮件管理信息。",
  "接收邮件营销信息",
  "发送邮件",
  "邮件发送请求失败。",
  "邮件主题预览",
  "是否发送此邮件？\n\n对象：{target}\n主题：{subject}\n预计发送：{count} 封",
  "邮件已加入发送队列。",
  "已有账户？",
  "该邮箱已注册。",
  "该 ID 已被使用。",
  "使用目的",
  "同意服务条款",
  "服务条款同意",
  "请同意服务条款以及个人信息的收集和使用。",
  "拥有已验证邮箱",
  "无法向没有已验证邮箱的用户发送。",
  "拥有已验证邮箱、同意营销邮件且未被封禁的用户",
  "已验证",
  "日期和时间",
  "输入的信息仅用于账户创建、审批、身份确认和账户恢复。注销或保留目的完成后，除法律规定的保留期限外，将予以销毁。",
  "汇总查看直属用户和所有下级代理所属用户。",
  "资产转换完成",
  "您编写的邮件正文将显示在此处。",
  "等待重试",
  "累计",
  "将被计入。",
  "专用注册链接",
  "全部同意",
  "全部发送对象",
  "访问记录保护",
  "开始访问。",
  "输入信息",
  "整个组织",
  "组织总注册人数",
  "要查看的代理",
  "直属",
  "直属注册人数",
  "由直属代理全部领取",
  "处理时间 / 错误",
  "最近 30 天",
  "最近 7 天",
  "最近资产转换",
  "最近积分累计",
  "由最高级代理全部领取",
  "各组织的推荐用户奖励积分将计入",
  "推荐代码",
  "推荐代码或代理线代码",
  "无法确认推荐代码。",
  "为目标创建信息按钮失败",
  "测试收件邮箱",
  "请输入测试收件邮箱。",
  "牌桌组结算政策",
  "保存牌桌组结算政策失败",
  "由指定代理全部领取",
  "积分盖章",
  "积分转资产失败。",
  "可以查看积分状态，但只有对应的 lv2 代理本人可以将积分转换为资产。",
  "积分已转换为资产。",
  "显示昵称",
  "若不同意必需的个人信息收集，将无法注册。",
  "同意所有必填和可选项目。",
  "请确认必需条款和隐私说明。",
  "请输入必填信息，确认个人信息收集与使用说明后完成注册。",
  "必需确认",
  "底部说明",
  "下级",
  "下级注册人数",
  "下级组织用户",
  "创建下级代理或普通用户账户。输入的账户信息在创建后立即生效。",
  "每行输入一个 agent_id:percent。percent 总和必须为 1 或 100。",
  "点击项目可查看单独发送结果。",
  "当前等待发送",
  "该推荐代码当前不可用。",
  "按当前设置创建目标项目",
  "在当前代理下创建普通用户。",
  "当前编辑：",
  "当前已暂停注册。",
  "启用",
  "会员识别、账户管理、身份确认和账户恢复",
  "为进行会员识别及账户管理/恢复，我们会处理 ID、昵称、邮箱和验证信息，并在目的达成后依据相关法律保留或删除。",
  "直到账户注销或法律规定的期限",
  "注册",
  "未找到注册 API。",
  "注册链接已复制。",
  "为注册和账户管理，我们会收集以下个人信息。请确认内容后继续注册。",
  "注册说明",
  "无法处理注册请求。",
  "注册请求已被拒绝。",
  "注册已完成。您现在可以直接登录。",
  "注册请求已完成。已审批的账户可立即登录。",
  "正在处理注册…"
];

const viValues = [
  "* Ảnh nền có thể tải lên tối đa 5 MB. Vẫn hỗ trợ nhập URL trực tiếp.",
  "* Ảnh nền này chỉ áp dụng cho mục tiêu thiết bị/ngôn ngữ đã chọn. Quốc gia hiện không được sử dụng và sẽ lưu là ALL. Muốn dùng nền khác nhau theo desktop/mobile hoặc ngôn ngữ, hãy tạo từng mục tiêu riêng.",
  "/events/avatar-reward hoặc https://...",
  "Nhập ít nhất 8 ký tự",
  "Giới hạn theo đơn vị BB. Nhập 0 để không giới hạn.",
  "Event Fee % phải là số từ 0 đến 100.",
  "Rake % phải là số từ 0 đến 100.",
  "Rake Cap BB phải là số từ 0 trở lên.",
  "Hàng đợi email Redis",
  "Thử lại lỗi SMTP",
  "[Tùy chọn]",
  "[Bắt buộc]",
  "all / Máy tính + Di động",
  "all / Tất cả ngôn ngữ",
  "desktop / Máy tính",
  "ko / Tiếng Hàn",
  "Chỉ vào tài khoản đại lý lv2",
  "Điểm thưởng giới thiệu lv2",
  "mobile / Di động",
  "Chuyển toàn bộ {amount} USDT thành tài sản",
  "Chuyển toàn bộ {amount} điểm USDT thành tài sản của đại lý hiện tại?",
  "sẽ được cộng. Mỗi người dùng chỉ được đóng dấu một lần.",
  "Không có người dùng đăng ký.",
  "Không thể tải trạng thái đăng ký.",
  "Bạn có thể kiểm tra trạng thái phê duyệt sau khi đăng ký.",
  "Ngày đăng ký",
  "Mỗi ô là một mục nút thông tin riêng. Nếu chưa có, hệ thống sẽ sao chép cài đặt hiện tại để tạo; nếu đã có, hãy mở mục đó để đổi ảnh nền riêng.",
  "Có thể gửi riêng lẻ",
  "Đang tải kết quả gửi riêng lẻ...",
  "Không có lịch sử gửi riêng lẻ.",
  "Không thể tải lịch sử gửi riêng lẻ.",
  "Đồng ý thu thập và sử dụng thông tin cá nhân",
  "Thông báo thu thập và sử dụng thông tin cá nhân",
  "Thông báo quyền riêng tư",
  "Không có kết quả tìm kiếm.",
  "Đang tìm kiếm",
  "Vấn đề tài khoản hãy liên hệ quản trị viên cấp trên",
  "Kiểm tra trạng thái tài khoản và quyền truy cập.",
  "Hãy kiểm tra loại tài khoản và thông tin bắt buộc trước khi tạo. Tài khoản mới sẽ được liên kết ngay dưới đại lý hiện tại.",
  "Thông tin tài khoản",
  "Dùng để xác minh và khôi phục tài khoản.",
  "Nhập chính xác thông tin tài khoản và khôi phục.",
  "Tài khoản phải do chính chủ hoặc người có thẩm quyền hợp pháp tạo. Việc chia sẻ tài khoản, lạm dụng quyền và cản trở vận hành dịch vụ có thể bị hạn chế.",
  "Không chọn duy trì đăng nhập trên thiết bị dùng chung.",
  "Truy cập công cụ quản trị",
  "Dành cho dịch vụ quản trị",
  "Tên này sẽ hiển thị trong giao diện quản trị.",
  "Nhập thông tin tài khoản quản trị viên.",
  "Hướng dẫn đăng nhập quản trị viên",
  "Menu quản trị",
  "Mở menu quản trị",
  "Phê duyệt quản trị viên",
  "Chỉ tài khoản đã được quản trị viên phê duyệt mới có thể truy cập.",
  "Tài khoản cần phê duyệt có thể đăng nhập sau khi hoàn tất phê duyệt.",
  "Nhập ID quản trị viên",
  "Đăng nhập quản trị viên",
  "Trang chủ quản trị",
  "Kiểm tra quyền",
  "Hiện có",
  "Mở mục tiêu hiện có",
  "Tài khoản của tôi",
  "URL cửa sổ nội bộ",
  "Mục tiêu hiển thị / nền riêng",
  "Tổng điểm đã nhận",
  "Nhập biệt danh từ 2 đến 16 ký tự.",
  "Đến mốc 20 USDT tiếp theo",
  "Người dùng chờ phần thưởng tiếp theo",
  "Đang chờ",
  "Hàng đợi",
  "Đang thêm vào hàng đợi...",
  "Đối tượng",
  "Nhập chính xác và phân biệt chữ hoa chữ thường.",
  "Máy tính",
  "Nhập lại cùng một mật khẩu.",
  "Không có email đăng ký",
  "Thiết bị",
  "Quản lý nhanh nền theo thiết bị/ngôn ngữ",
  "Các lần đăng nhập và hoạt động quản trị chính được ghi lại để bảo mật.",
  "Ghi nhớ ID đăng nhập",
  "Đang đăng nhập…",
  "Quay lại đăng nhập",
  "Đi đến trang đăng nhập",
  "Đây là ID dùng để đăng nhập.",
  "Đăng nhập thất bại nhiều lần có thể tạm khóa tài khoản. Hãy nhờ quản trị viên kiểm tra trạng thái.",
  "Nhập",
  "Sao chép liên kết",
  "Đồng ý tiếp thị",
  "{count} người dùng đồng ý tiếp thị",
  "Không có người dùng đồng ý nhận email tiếp thị.",
  "Soạn email",
  "Tiêu đề email",
  "Nhập tiêu đề và nội dung email.",
  "người mỗi",
  "Di động",
  "Chưa tạo",
  "Cài đặt người nhận thưởng nhiệm vụ",
  "Chưa xác minh",
  "Tiêu đề hiển thị trong hộp thư đến",
  "Nhập ID tài khoản quản trị viên đã được cấp.",
  "Nhập ID quản trị viên đã được cấp.",
  "Đối tượng gửi",
  "Xem trước gửi",
  "Lịch sử gửi",
  "Nhập nội dung cần gửi.",
  "Chọn người dùng để gửi.",
  "Không có nền",
  "Tải ảnh nền / URL",
  "Tải ảnh nền thất bại (hãy kiểm tra API tải lên của máy chủ)",
  "Hãy tải ảnh nền không quá 5 MB.",
  "Lô",
  "URL nút",
  "Nhãn nút",
  "Chuyển đổi",
  "Đang chuyển đổi...",
  "Tài sản sau chuyển đổi",
  "Xem",
  "Thông báo bảo mật",
  "Thời gian lưu giữ",
  "Được bảo vệ",
  "Email này được gửi bởi Night Poker Club.",
  "Tiêu đề nội dung",
  "Công thức phân phối",
  "Công thức phải theo dạng agent_id:percent và tổng percent phải bằng 1 hoặc 100. Ví dụ: 1002:0.7 / 1001:0.3",
  "Nhập lại mật khẩu",
  "Nhập mật khẩu",
  "Xác nhận mật khẩu",
  "Mật khẩu xác nhận không khớp.",
  "Nhập mật khẩu ít nhất 8 ký tự.",
  "Hãy dùng mật khẩu khác với các dịch vụ khác.",
  "Để trống để dùng tiêu đề email",
  "Điểm khả dụng",
  "Nhập địa chỉ email hợp lệ.",
  "Người nhận thưởng",
  "Đại lý cấp trên: {id}",
  "Đại lý cấp trên nhận toàn bộ",
  "Tạo tài khoản mới.",
  "Nhập thông tin cơ bản cần thiết để sử dụng dịch vụ.",
  "Chọn",
  "Thành công",
  "Đại lý trực thuộc",
  "Đã đồng ý",
  "Không đồng ý",
  "Người nhận",
  "Thông tin thu thập",
  "Phương thức nhận",
  "agent_id người nhận",
  "Nhập agent_id của người nhận.",
  "Lưu cài đặt người nhận thất bại",
  "Chỉ superadmin · Gửi qua hàng đợi email worker",
  "Dấu",
  "Đã đóng dấu",
  "Người dùng đã đóng dấu",
  "Xác minh tài khoản đã duyệt",
  "Chỉ dành cho tài khoản quản trị viên đã duyệt",
  "Đăng nhập bằng tài khoản quản trị viên đã duyệt để dùng bảng điều khiển vận hành và chức năng quản lý.",
  "Sử dụng chức năng vận hành trong phạm vi được duyệt.",
  "Lần thử",
  "Theo mẫu worker thực tế",
  "Hãy sao chép liên kết bên dưới.",
  "Áp dụng URL cửa sổ sự kiện thưởng avatar",
  "Để mở cửa sổ sự kiện thưởng avatar, hãy nhập vào URL chuyển đến:",
  "ID",
  "ID, biệt danh và mật khẩu là bắt buộc. Chỉ nhập mật khẩu phụ khi cần.",
  "ID, biệt danh, email, mật khẩu",
  "Nhập 4–20 ký tự gồm chữ cái, số và dấu gạch dưới.",
  "Chưa có tài khoản?",
  "Chưa có lịch sử gửi.",
  "Chưa có lịch sử chuyển đổi.",
  "Chưa có lịch sử tích lũy.",
  "Dịch vụ quản trị an toàn",
  "Đồng ý điều khoản",
  "sẽ nhận được thư này.",
  "Trạng thái đăng ký đại lý",
  "Quản lý cấp bậc đại lý, người dùng trực thuộc, phí, tài sản và chính sách thưởng nhiệm vụ.",
  "Không thể tải danh sách đại lý.",
  "Không trả thưởng bổ sung cho đại lý",
  "Mã đại lý",
  "Phân phối cho nhiều đại lý",
  "Khuyến nghị kết hợp chữ cái, số và ký tự đặc biệt.",
  "4–20 chữ cái và số",
  "Ví dụ: Truy cập trang web",
  "Số gửi dự kiến",
  "Đăng ký tổ chức hôm nay",
  "Quá nhiều yêu cầu. Vui lòng thử lại sau.",
  "Ưu tiên",
  "Tìm người dùng",
  "Tìm người dùng thất bại.",
  "Mã người dùng",
  "Mã người dùng, ID, biệt danh",
  "Tìm theo mã người dùng, ID, biệt danh hoặc đại lý trực thuộc",
  "Cài đặt này không ảnh hưởng tiền thưởng bàn của người dùng; chỉ xác định người nhận phần thưởng bổ sung được tính từ agent_share.",
  "Email",
  "Đang tải thông tin quản lý email...",
  "Không thể tải thông tin quản lý email.",
  "Nhận thông tin tiếp thị qua email",
  "Gửi email",
  "Yêu cầu gửi email thất bại.",
  "Xem trước tiêu đề email",
  "Gửi email này?\n\nĐối tượng: {target}\nTiêu đề: {subject}\nSố gửi dự kiến: {count}",
  "Email đã được thêm vào hàng đợi gửi.",
  "Đã có tài khoản?",
  "Email này đã được đăng ký.",
  "ID này đã được sử dụng.",
  "Mục đích sử dụng",
  "Đồng ý Điều khoản dịch vụ",
  "Đồng ý Điều khoản dịch vụ",
  "Hãy đồng ý Điều khoản dịch vụ và việc thu thập, sử dụng thông tin cá nhân.",
  "Có email đã xác minh",
  "Không thể gửi cho người dùng không có email đã xác minh.",
  "Người dùng có email đã xác minh, đồng ý email tiếp thị và không bị chặn",
  "Đã xác minh",
  "Ngày giờ",
  "Thông tin đã nhập chỉ được xử lý để tạo và duyệt tài khoản, xác minh danh tính và khôi phục tài khoản. Dữ liệu sẽ bị xóa sau khi rút tài khoản hoặc đạt mục đích lưu giữ, trừ thời hạn theo luật.",
  "Xem tổng cộng người dùng trực tiếp và người dùng thuộc tất cả đại lý cấp dưới.",
  "Hoàn tất chuyển đổi tài sản",
  "Nội dung email bạn viết sẽ hiển thị tại đây.",
  "Chờ thử lại",
  "Tích lũy",
  "sẽ được cộng.",
  "URL đăng ký riêng",
  "Đồng ý tất cả",
  "Tất cả đối tượng gửi",
  "Bảo vệ nhật ký truy cập",
  "Bắt đầu truy cập.",
  "Nhập thông tin",
  "Toàn bộ tổ chức",
  "Tổng người đăng ký trong tổ chức",
  "Đại lý cần xem",
  "Trực tiếp",
  "Đăng ký trực tiếp",
  "Đại lý trực tiếp nhận toàn bộ",
  "Thời gian xử lý / Lỗi",
  "30 ngày gần đây",
  "7 ngày gần đây",
  "Chuyển đổi tài sản gần đây",
  "Tích lũy điểm gần đây",
  "Đại lý cấp cao nhất nhận toàn bộ",
  "Điểm thưởng người dùng giới thiệu của mỗi tổ chức được cộng",
  "Mã giới thiệu",
  "Mã giới thiệu hoặc mã tuyến đại lý",
  "Không thể xác minh mã giới thiệu.",
  "Tạo nút thông tin cho mục tiêu thất bại",
  "Email nhận thử",
  "Nhập email nhận thử.",
  "Chính sách quyết toán nhóm bàn",
  "Lưu chính sách quyết toán nhóm bàn thất bại",
  "Đại lý được chỉ định nhận toàn bộ",
  "Dấu điểm",
  "Chuyển điểm thành tài sản thất bại.",
  "Có thể xem trạng thái điểm, nhưng chỉ chính đại lý lv2 tương ứng mới có thể chuyển điểm thành tài sản.",
  "Điểm đã được chuyển thành tài sản.",
  "Biệt danh hiển thị",
  "Đăng ký sẽ bị hạn chế nếu không đồng ý thu thập thông tin cá nhân bắt buộc.",
  "Đồng ý tất cả mục bắt buộc và tùy chọn.",
  "Kiểm tra điều khoản bắt buộc và thông báo quyền riêng tư.",
  "Nhập thông tin bắt buộc, kiểm tra thông báo thu thập và sử dụng thông tin cá nhân rồi hoàn tất đăng ký.",
  "Xác nhận bắt buộc",
  "Thông báo cuối trang",
  "Cấp dưới",
  "Đăng ký cấp dưới",
  "Người dùng tổ chức cấp dưới",
  "Tạo đại lý cấp dưới hoặc tài khoản người dùng thường. Thông tin nhập vào có hiệu lực ngay sau khi tạo.",
  "Nhập mỗi dòng một agent_id:percent. Tổng percent phải bằng 1 hoặc 100.",
  "Chọn một mục để xem kết quả gửi riêng lẻ.",
  "Hiện đang chờ gửi",
  "Mã giới thiệu này hiện không khả dụng.",
  "Tạo mục tiêu từ cài đặt hiện tại",
  "Tạo người dùng thường dưới đại lý hiện tại.",
  "Đang chỉnh sửa:",
  "Đăng ký hiện đang tạm dừng.",
  "Hoạt động",
  "Nhận dạng thành viên, quản lý tài khoản, xác minh danh tính và khôi phục tài khoản",
  "Để nhận dạng thành viên và quản lý/khôi phục tài khoản, chúng tôi xử lý ID, biệt danh, email và thông tin xác minh, sau đó lưu giữ hoặc xóa theo luật khi đạt mục đích.",
  "Cho đến khi đóng tài khoản hoặc hết thời hạn theo luật",
  "Đăng ký",
  "Không tìm thấy API đăng ký.",
  "Đã sao chép liên kết đăng ký.",
  "Chúng tôi thu thập thông tin cá nhân dưới đây để đăng ký và quản lý tài khoản. Hãy đọc trước khi tiếp tục.",
  "Hướng dẫn đăng ký",
  "Không thể xử lý yêu cầu đăng ký.",
  "Yêu cầu đăng ký đã bị từ chối.",
  "Đăng ký đã hoàn tất. Bạn có thể đăng nhập ngay.",
  "Yêu cầu đăng ký đã hoàn tất. Tài khoản được duyệt có thể đăng nhập ngay.",
  "Đang xử lý đăng ký…"
];

const thValues = [
  "* อัปโหลดภาพพื้นหลังได้สูงสุด 5 MB และยังสามารถกรอก URL โดยตรงได้",
  "* พื้นหลังนี้ใช้เฉพาะกับเป้าหมายอุปกรณ์/ภาษาที่เลือก ขณะนี้ไม่ใช้ค่าประเทศและจะบันทึกเป็น ALL หากต้องการพื้นหลังต่างกันตาม desktop/mobile หรือภาษา ให้สร้างรายการเป้าหมายแยกกัน",
  "/events/avatar-reward หรือ https://...",
  "กรอกอย่างน้อย 8 ตัวอักษร",
  "ขีดจำกัดหน่วย BB ใส่ 0 หากไม่จำกัด",
  "Event Fee % ต้องเป็นตัวเลขระหว่าง 0 ถึง 100",
  "Rake % ต้องเป็นตัวเลขระหว่าง 0 ถึง 100",
  "Rake Cap BB ต้องเป็นตัวเลขตั้งแต่ 0 ขึ้นไป",
  "คิวอีเมล Redis",
  "ลองส่ง SMTP ที่ล้มเหลวอีกครั้ง",
  "[ไม่บังคับ]",
  "[จำเป็น]",
  "all / เดสก์ท็อป + มือถือ",
  "all / ทุกภาษา",
  "desktop / เดสก์ท็อป",
  "ko / ภาษาเกาหลี",
  "เฉพาะบัญชีเอเจนต์ lv2",
  "คะแนนรางวัลแนะนำ lv2",
  "mobile / มือถือ",
  "แปลง {amount} USDT ทั้งหมดเป็นสินทรัพย์",
  "แปลงคะแนน {amount} USDT ทั้งหมดเป็นสินทรัพย์ของเอเจนต์ปัจจุบันหรือไม่?",
  "จะถูกเพิ่มให้ ผู้ใช้แต่ละคนจะถูกประทับตราเพียงครั้งเดียว",
  "ไม่มีผู้ใช้ที่ลงทะเบียน",
  "โหลดสถานะการลงทะเบียนไม่สำเร็จ",
  "สามารถตรวจสอบสถานะการอนุมัติได้หลังลงทะเบียน",
  "วันที่ลงทะเบียน",
  "แต่ละช่องเป็นรายการปุ่มข้อมูลแยกกัน หากไม่มี ระบบจะคัดลอกการตั้งค่าปัจจุบันเพื่อสร้างใหม่ หากมีแล้ว ให้เปิดรายการนั้นเพื่อเปลี่ยนภาพพื้นหลังแยกกัน",
  "ส่งรายบุคคลได้",
  "กำลังโหลดผลการส่งรายบุคคล...",
  "ไม่มีประวัติการส่งรายบุคคล",
  "โหลดประวัติการส่งรายบุคคลไม่สำเร็จ",
  "ยินยอมให้เก็บรวบรวมและใช้ข้อมูลส่วนบุคคล",
  "คำชี้แจงการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคล",
  "ประกาศความเป็นส่วนตัว",
  "ไม่พบผลการค้นหา",
  "กำลังค้นหา",
  "หากมีปัญหาเกี่ยวกับบัญชี โปรดติดต่อผู้ดูแลระดับสูงกว่า",
  "ตรวจสอบสถานะบัญชีและสิทธิ์การเข้าถึง",
  "ตรวจสอบประเภทบัญชีและข้อมูลที่จำเป็นก่อนสร้าง บัญชีใหม่จะเชื่อมใต้เอเจนต์ปัจจุบันทันที",
  "ข้อมูลบัญชี",
  "ใช้สำหรับยืนยันและกู้คืนบัญชี",
  "กรอกข้อมูลบัญชีและการกู้คืนให้ถูกต้อง",
  "บัญชีต้องสร้างโดยเจ้าของหรือผู้มีอำนาจโดยชอบ การแชร์บัญชี ใช้สิทธิ์ผิดวัตถุประสงค์ หรือรบกวนการให้บริการอาจถูกจำกัด",
  "อย่าเลือกคงสถานะเข้าสู่ระบบบนอุปกรณ์ที่ใช้ร่วมกัน",
  "เข้าถึงเครื่องมือผู้ดูแล",
  "สำหรับบริการผู้ดูแล",
  "ชื่อนี้จะแสดงในหน้าผู้ดูแล",
  "กรอกข้อมูลบัญชีผู้ดูแล",
  "คำแนะนำการเข้าสู่ระบบผู้ดูแล",
  "เมนูผู้ดูแล",
  "เปิดเมนูผู้ดูแล",
  "การอนุมัติของผู้ดูแล",
  "เฉพาะบัญชีที่ผู้ดูแลอนุมัติแล้วเท่านั้นที่เข้าถึงได้",
  "บัญชีที่ต้องรออนุมัติจะเข้าสู่ระบบได้หลังอนุมัติเสร็จ",
  "กรอก ID ผู้ดูแล",
  "เข้าสู่ระบบสำหรับผู้ดูแล",
  "หน้าหลักผู้ดูแล",
  "ตรวจสอบสิทธิ์",
  "ที่มีอยู่",
  "เปิดรายการเป้าหมายที่มีอยู่",
  "บัญชีของฉัน",
  "URL ป๊อปอัปภายใน",
  "เป้าหมายการแสดงผล / พื้นหลังรายรายการ",
  "คะแนนสะสมทั้งหมด",
  "กรอกชื่อเล่น 2–16 ตัวอักษร",
  "ถึง 20 USDT ถัดไป",
  "ผู้ใช้ที่รอรางวัลถัดไป",
  "รอดำเนินการ",
  "คิว",
  "กำลังเพิ่มเข้าคิว...",
  "เป้าหมาย",
  "กรอกให้ถูกต้องและตรงตามตัวพิมพ์ใหญ่-เล็ก",
  "เดสก์ท็อป",
  "กรอกรหัสผ่านเดียวกัน",
  "ไม่มีอีเมลที่ลงทะเบียน",
  "อุปกรณ์",
  "จัดการพื้นหลังอย่างรวดเร็วตามอุปกรณ์/ภาษา",
  "การเข้าสู่ระบบและกิจกรรมผู้ดูแลที่สำคัญจะถูกบันทึกเพื่อความปลอดภัย",
  "จดจำ ID เข้าสู่ระบบ",
  "กำลังเข้าสู่ระบบ…",
  "กลับไปหน้าเข้าสู่ระบบ",
  "ไปหน้าเข้าสู่ระบบ",
  "นี่คือ ID ที่ใช้เข้าสู่ระบบ",
  "การเข้าสู่ระบบล้มเหลวซ้ำอาจทำให้บัญชีถูกล็อกชั่วคราว โปรดให้ผู้ดูแลตรวจสอบสถานะบัญชี",
  "กรอก",
  "คัดลอกลิงก์",
  "ยินยอมรับการตลาด",
  "ผู้ใช้ที่ยินยอมรับการตลาด {count} คน",
  "ไม่มีผู้ใช้ที่ยินยอมรับอีเมลการตลาด",
  "เขียนอีเมล",
  "หัวข้ออีเมล",
  "กรอกหัวข้อและเนื้อหาอีเมล",
  "คนต่อ",
  "มือถือ",
  "ยังไม่สร้าง",
  "ตั้งค่าผู้รับรางวัลภารกิจ",
  "ยังไม่ยืนยัน",
  "หัวข้อที่แสดงในกล่องจดหมาย",
  "กรอก ID บัญชีผู้ดูแลที่ได้รับ",
  "กรอก ID ผู้ดูแลที่ได้รับ",
  "ผู้รับ",
  "ตัวอย่างการส่ง",
  "ประวัติการส่ง",
  "กรอกเนื้อหาที่จะส่ง",
  "เลือกผู้ใช้ที่จะส่งถึง",
  "ไม่มีพื้นหลัง",
  "อัปโหลดภาพพื้นหลัง / URL",
  "อัปโหลดภาพพื้นหลังไม่สำเร็จ (ตรวจสอบ API อัปโหลดของเซิร์ฟเวอร์)",
  "อัปโหลดภาพพื้นหลังขนาดไม่เกิน 5 MB",
  "แบตช์",
  "URL ปุ่ม",
  "ข้อความปุ่ม",
  "แปลง",
  "กำลังแปลง...",
  "สินทรัพย์หลังแปลง",
  "ดู",
  "ประกาศด้านความปลอดภัย",
  "ระยะเวลาการเก็บรักษา",
  "ได้รับการปกป้อง",
  "อีเมลนี้ส่งโดย Night Poker Club",
  "ชื่อเนื้อหา",
  "สูตรการแบ่ง",
  "สูตรต้องอยู่ในรูป agent_id:percent และผลรวม percent ต้องเท่ากับ 1 หรือ 100 ตัวอย่าง: 1002:0.7 / 1001:0.3",
  "กรอกรหัสผ่านอีกครั้ง",
  "กรอกรหัสผ่าน",
  "ยืนยันรหัสผ่าน",
  "รหัสผ่านยืนยันไม่ตรงกัน",
  "กรอกรหัสผ่านอย่างน้อย 8 ตัวอักษร",
  "ใช้รหัสผ่านที่ต่างจากบริการอื่น",
  "เว้นว่างเพื่อใช้หัวข้ออีเมล",
  "คะแนนที่ใช้ได้",
  "กรอกที่อยู่อีเมลที่ถูกต้อง",
  "ผู้รับรางวัล",
  "เอเจนต์ระดับบน: {id}",
  "เอเจนต์ระดับบนรับทั้งหมด",
  "สร้างบัญชีใหม่",
  "กรอกข้อมูลพื้นฐานที่จำเป็นต่อการใช้บริการ",
  "เลือก",
  "สำเร็จ",
  "เอเจนต์ที่สังกัด",
  "ยินยอมแล้ว",
  "ไม่ยินยอม",
  "ผู้รับ",
  "ข้อมูลที่เก็บรวบรวม",
  "วิธีรับผลประโยชน์",
  "agent_id ผู้รับ",
  "กรอก agent_id ผู้รับ",
  "บันทึกการตั้งค่าผู้รับไม่สำเร็จ",
  "เฉพาะซูเปอร์แอดมิน · ส่งผ่านคิว email worker",
  "ประทับตรา",
  "ประทับตราแล้ว",
  "ผู้ใช้ที่ประทับตราแล้ว",
  "ตรวจสอบบัญชีที่อนุมัติแล้ว",
  "เฉพาะบัญชีผู้ดูแลที่อนุมัติแล้ว",
  "เข้าสู่ระบบด้วยบัญชีผู้ดูแลที่อนุมัติแล้วเพื่อใช้แดชบอร์ดปฏิบัติการและฟังก์ชันจัดการ",
  "ใช้ฟังก์ชันปฏิบัติการภายในขอบเขตที่อนุมัติ",
  "ครั้งที่ลอง",
  "อ้างอิงเทมเพลต worker จริง",
  "คัดลอกลิงก์ด้านล่าง",
  "ใช้ URL ป๊อปอัปกิจกรรมรางวัลอวตาร",
  "หากต้องการเปิดป๊อปอัปกิจกรรมรางวัลอวตาร ให้กรอกใน URL ปลายทาง:",
  "ID",
  "ID ชื่อเล่น และรหัสผ่านเป็นข้อมูลบังคับ กรอกรหัสผ่านรองเมื่อจำเป็นเท่านั้น",
  "ID, ชื่อเล่น, อีเมล, รหัสผ่าน",
  "กรอก 4–20 ตัวอักษร โดยใช้ตัวอักษรอังกฤษ ตัวเลข และขีดล่าง",
  "ยังไม่มีบัญชีใช่ไหม?",
  "ยังไม่มีประวัติการส่ง",
  "ยังไม่มีประวัติการแปลง",
  "ยังไม่มีประวัติการสะสม",
  "บริการผู้ดูแลที่ปลอดภัย",
  "ยินยอมข้อกำหนด",
  "จะได้รับข้อความนี้",
  "สถานะการสมัครเอเจนต์",
  "จัดการลำดับชั้นเอเจนต์ ผู้ใช้ในสังกัด ค่าธรรมเนียม สินทรัพย์ และนโยบายรางวัลภารกิจ",
  "โหลดรายชื่อเอเจนต์ไม่สำเร็จ",
  "ไม่จ่ายรางวัลเพิ่มเติมให้เอเจนต์",
  "รหัสเอเจนต์",
  "แบ่งให้หลายเอเจนต์",
  "แนะนำให้ใช้ตัวอักษร ตัวเลข และอักขระพิเศษร่วมกัน",
  "ตัวอักษรและตัวเลข 4–20 ตัว",
  "ตัวอย่าง: ไปยังเว็บไซต์",
  "จำนวนส่งโดยประมาณ",
  "ผู้สมัครขององค์กรวันนี้",
  "มีคำขอมากเกินไป โปรดลองใหม่ภายหลัง",
  "ลำดับความสำคัญ",
  "ค้นหาผู้ใช้",
  "ค้นหาผู้ใช้ไม่สำเร็จ",
  "รหัสผู้ใช้",
  "รหัสผู้ใช้, ID, ชื่อเล่น",
  "ค้นหารหัสผู้ใช้ ID ชื่อเล่น หรือเอเจนต์ที่สังกัด",
  "การตั้งค่านี้ไม่กระทบรางวัลโต๊ะของผู้ใช้ แต่กำหนดเฉพาะผู้รับรางวัลเพิ่มเติมที่คำนวณจาก agent_share",
  "อีเมล",
  "กำลังโหลดข้อมูลจัดการอีเมล...",
  "โหลดข้อมูลจัดการอีเมลไม่สำเร็จ",
  "รับข้อมูลการตลาดทางอีเมล",
  "ส่งอีเมล",
  "คำขอส่งอีเมลล้มเหลว",
  "ตัวอย่างหัวข้ออีเมล",
  "ส่งอีเมลนี้หรือไม่?\n\nเป้าหมาย: {target}\nหัวข้อ: {subject}\nจำนวนส่งโดยประมาณ: {count}",
  "เพิ่มอีเมลเข้าคิวส่งแล้ว",
  "มีบัญชีอยู่แล้วใช่ไหม?",
  "อีเมลนี้ลงทะเบียนแล้ว",
  "ID นี้ถูกใช้งานแล้ว",
  "วัตถุประสงค์การใช้",
  "ยอมรับข้อกำหนดการใช้บริการ",
  "ความยินยอมต่อข้อกำหนดการใช้บริการ",
  "โปรดยอมรับข้อกำหนดการใช้บริการและการเก็บรวบรวม/ใช้ข้อมูลส่วนบุคคล",
  "มีอีเมลที่ยืนยันแล้ว",
  "ไม่สามารถส่งให้ผู้ใช้ที่ไม่มีอีเมลยืนยันแล้วได้",
  "ผู้ใช้ที่มีอีเมลยืนยันแล้ว ยินยอมอีเมลการตลาด และไม่ถูกบล็อก",
  "ยืนยันแล้ว",
  "วันที่และเวลา",
  "ข้อมูลที่กรอกจะใช้เฉพาะเพื่อสร้างและอนุมัติบัญชี ยืนยันตัวตน และกู้คืนบัญชี หลังถอนบัญชีหรือบรรลุวัตถุประสงค์จะลบข้อมูล ยกเว้นระยะเวลาที่กฎหมายกำหนด",
  "ดูผลรวมของผู้ใช้ตรงของคุณและผู้ใช้ภายใต้เอเจนต์ระดับล่างทั้งหมด",
  "แปลงสินทรัพย์เสร็จสิ้น",
  "เนื้อหาอีเมลที่เขียนจะแสดงที่นี่",
  "รอลองใหม่",
  "สะสม",
  "จะถูกเพิ่มให้",
  "URL สมัครเฉพาะ",
  "ยอมรับทั้งหมด",
  "ผู้รับทั้งหมด",
  "การปกป้องบันทึกการเข้าถึง",
  "เริ่มการเข้าถึง",
  "กรอกข้อมูล",
  "ทั้งองค์กร",
  "ผู้สมัครทั้งหมดขององค์กร",
  "เอเจนต์ที่ต้องการดู",
  "โดยตรง",
  "ผู้สมัครโดยตรง",
  "เอเจนต์โดยตรงรับทั้งหมด",
  "เวลาประมวลผล / ข้อผิดพลาด",
  "30 วันที่ผ่านมา",
  "7 วันที่ผ่านมา",
  "การแปลงสินทรัพย์ล่าสุด",
  "การสะสมคะแนนล่าสุด",
  "เอเจนต์ระดับสูงสุดรับทั้งหมด",
  "คะแนนรางวัลผู้ใช้ที่แนะนำของแต่ละองค์กรจะถูกเพิ่ม",
  "รหัสแนะนำ",
  "รหัสแนะนำหรือรหัสสายเอเจนต์",
  "ไม่สามารถตรวจสอบรหัสแนะนำได้",
  "สร้างปุ่มข้อมูลสำหรับเป้าหมายไม่สำเร็จ",
  "อีเมลผู้รับทดสอบ",
  "กรอกอีเมลผู้รับทดสอบ",
  "นโยบายชำระบัญชีกลุ่มโต๊ะ",
  "บันทึกนโยบายชำระบัญชีกลุ่มโต๊ะไม่สำเร็จ",
  "เอเจนต์ที่ระบุรับทั้งหมด",
  "ประทับตราคะแนน",
  "แปลงคะแนนเป็นสินทรัพย์ไม่สำเร็จ",
  "ดูสถานะคะแนนได้ แต่เฉพาะเอเจนต์ lv2 เจ้าของบัญชีเท่านั้นที่แปลงคะแนนเป็นสินทรัพย์ได้",
  "คะแนนถูกแปลงเป็นสินทรัพย์แล้ว",
  "ชื่อเล่นที่แสดง",
  "การสมัครจะถูกจำกัดหากไม่ยินยอมให้เก็บข้อมูลส่วนบุคคลที่จำเป็น",
  "ยอมรับรายการบังคับและไม่บังคับทั้งหมด",
  "ตรวจสอบข้อกำหนดที่จำเป็นและประกาศความเป็นส่วนตัว",
  "กรอกข้อมูลที่จำเป็น ตรวจสอบคำชี้แจงการเก็บและใช้ข้อมูลส่วนบุคคล แล้วสมัครให้เสร็จ",
  "การยืนยันที่จำเป็น",
  "ประกาศด้านล่าง",
  "ระดับล่าง",
  "ผู้สมัครระดับล่าง",
  "ผู้ใช้ในองค์กรระดับล่าง",
  "สร้างเอเจนต์ระดับล่างหรือบัญชีผู้ใช้ทั่วไป ข้อมูลบัญชีจะมีผลทันทีหลังสร้าง",
  "กรอก agent_id:percent หนึ่งรายการต่อบรรทัด ผลรวม percent ต้องเท่ากับ 1 หรือ 100",
  "เลือกรายการเพื่อดูผลการส่งรายบุคคล",
  "กำลังรอส่ง",
  "รหัสแนะนำนี้ไม่พร้อมใช้งานในขณะนี้",
  "สร้างรายการเป้าหมายจากการตั้งค่าปัจจุบัน",
  "สร้างผู้ใช้ทั่วไปใต้เอเจนต์ปัจจุบัน",
  "กำลังแก้ไข:",
  "ขณะนี้ระงับการสมัคร",
  "ใช้งาน",
  "ระบุตัวสมาชิก จัดการบัญชี ยืนยันตัวตน และกู้คืนบัญชี",
  "เพื่อระบุตัวสมาชิกและจัดการ/กู้คืนบัญชี เราประมวลผล ID ชื่อเล่น อีเมล และข้อมูลยืนยัน จากนั้นเก็บหรือลบตามกฎหมายเมื่อบรรลุวัตถุประสงค์",
  "จนกว่าจะปิดบัญชีหรือครบระยะเวลาตามกฎหมาย",
  "สมัครสมาชิก",
  "ไม่พบ API การสมัคร",
  "คัดลอกลิงก์สมัครแล้ว",
  "เราเก็บข้อมูลส่วนบุคคลด้านล่างเพื่อการสมัครและจัดการบัญชี โปรดตรวจสอบก่อนดำเนินการต่อ",
  "คำแนะนำการสมัคร",
  "ไม่สามารถประมวลผลคำขอสมัครได้",
  "คำขอสมัครถูกปฏิเสธ",
  "การลงทะเบียนเสร็จสมบูรณ์แล้ว คุณสามารถเข้าสู่ระบบได้ทันที",
  "คำขอสมัครเสร็จสมบูรณ์ บัญชีที่อนุมัติแล้วสามารถเข้าสู่ระบบได้ทันที",
  "กำลังประมวลผลการสมัคร…"
];

const jaValues = [
  "* 背景画像は最大5MBまでアップロードできます。既存のURL直接入力方式も利用できます。",
  "* この背景は選択したデバイス／言語ターゲットにのみ適用されます。国の値は現在使用しないため、保存時はALLに固定されます。desktop/mobileまたは言語ごとに背景を分ける場合は、各ターゲット項目を別々に作成して保存してください。",
  "/events/avatar-reward または https://...",
  "8文字以上入力",
  "BB単位の上限です。0の場合は上限なしです。",
  "Event Fee %は0～100の数値で入力してください。",
  "Rake %は0～100の数値で入力してください。",
  "Rake Cap BBは0以上の数値で入力してください。",
  "Redisメールキュー",
  "SMTP失敗を再試行",
  "[任意]",
  "[必須]",
  "all / デスクトップ＋モバイル",
  "all / すべての言語",
  "desktop / デスクトップ",
  "ko / 韓国語",
  "lv2エージェントアカウントのみに",
  "lv2紹介報酬ポイント",
  "mobile / モバイル",
  "{amount} USDTをすべて資産に変換",
  "{amount} USDTポイントをすべて現在のエージェント資産に変換しますか？",
  "が付与されます。1ユーザーにつきスタンプは1回のみです。",
  "登録ユーザーはいません。",
  "登録状況を読み込めませんでした。",
  "登録後に承認状況を確認できます。",
  "登録日",
  "各セルは個別の情報ボタン項目です。存在しない場合は現在の設定を複製して作成し、存在する場合はその項目を開いて背景画像を個別に変更できます。",
  "個別送信可能",
  "個別送信結果を読み込み中...",
  "個別送信履歴はありません。",
  "個別送信履歴を読み込めませんでした。",
  "個人情報の収集・利用への同意",
  "個人情報の収集・利用に関する案内",
  "プライバシー案内",
  "検索結果がありません。",
  "検索中",
  "アカウントの問題は上位管理者にお問い合わせください",
  "アカウント状態とアクセス権限を確認します。",
  "アカウント種類と必須情報を確認してから作成してください。作成されたアカウントは現在のエージェント配下にすぐ連結されます。",
  "アカウント情報",
  "アカウント確認と復旧に使用されます。",
  "アカウント情報と復旧情報を正確に入力してください。",
  "アカウントは本人または正当な権限を持つ利用者が作成する必要があります。アカウント共有、権限の不正利用、サービス運営の妨害は制限される場合があります。",
  "共有端末ではログイン状態を維持しないでください。",
  "管理ツールにアクセス",
  "管理サービス用",
  "管理画面に表示される名前です。",
  "管理者アカウント情報を入力してください。",
  "管理者ログインの案内",
  "管理者メニュー",
  "管理者メニューを開く",
  "管理者承認",
  "管理者の承認が完了したアカウントのみアクセスできます。",
  "管理者承認が必要なアカウントは、承認完了後にログインできます。",
  "管理者IDを入力",
  "管理者専用ログイン",
  "管理者ホーム",
  "権限確認",
  "既存",
  "既存のターゲット項目を開く",
  "自分のアカウント",
  "内部ポップアップURL",
  "表示ターゲット／個別背景基準",
  "累積獲得ポイント",
  "ニックネームは2～16文字で入力してください。",
  "次の20 USDTまで",
  "次回報酬待機ユーザー",
  "待機中",
  "キュー",
  "キューに登録中...",
  "対象",
  "大文字・小文字を区別して正確に入力してください。",
  "デスクトップ",
  "同じパスワードを入力してください。",
  "登録メールなし",
  "デバイス",
  "デバイス／言語別の背景クイック管理",
  "セキュリティのため、ログインと主な管理操作は記録されます。",
  "ログインIDを保存",
  "ログイン中…",
  "ログイン画面に戻る",
  "ログイン画面へ移動",
  "ログインに使用するIDです。",
  "ログイン失敗が繰り返されると、アカウントが一時的にロックされる場合があります。管理者に状態をご確認ください。",
  "入力してください",
  "リンクをコピー",
  "マーケティング受信同意",
  "マーケティング同意ユーザー {count}名",
  "マーケティングメールの受信同意者がいません。",
  "メール作成",
  "メール件名",
  "メールの件名と本文を入力してください。",
  "名ごと",
  "モバイル",
  "未作成",
  "ミッション賞金受益者設定",
  "未認証",
  "受信トレイに表示する件名",
  "発行された管理者アカウントIDを入力してください。",
  "発行された管理者IDを入力します。",
  "送信対象",
  "送信プレビュー",
  "送信履歴",
  "送信する内容を入力してください。",
  "送信するユーザーを選択してください。",
  "背景なし",
  "背景画像アップロード／URL",
  "背景画像のアップロードに失敗しました（サーバーのアップロードAPIを確認してください）",
  "背景画像は5MB以下でアップロードしてください。",
  "バッチ",
  "ボタンURL",
  "ボタン文言",
  "変換",
  "変換中...",
  "変換後の資産",
  "表示",
  "セキュリティ案内",
  "保有期間",
  "保護済み",
  "このメールはNight Poker Clubから送信されました。",
  "本文タイトル",
  "分配式",
  "分配式はagent_id:percent形式で、percentの合計は1または100である必要があります。例：1002:0.7 / 1001:0.3",
  "パスワードを再入力",
  "パスワードを入力",
  "パスワード確認",
  "確認用パスワードが一致しません。",
  "パスワードは8文字以上で入力してください。",
  "他のサービスとは異なるパスワードを設定してください。",
  "空欄の場合はメール件名を使用",
  "利用可能ポイント",
  "有効なメールアドレスを入力してください。",
  "賞金受益者",
  "上位エージェント：{id}",
  "上位エージェントが全額受領",
  "新しいアカウントを作成します。",
  "サービス利用に必要な基本情報を入力してください。",
  "選択",
  "成功",
  "所属エージェント",
  "受信同意",
  "受信不同意",
  "受信者",
  "収集項目",
  "受益方法",
  "受益者agent_id",
  "受益者agent_idを入力してください。",
  "受益者設定の保存に失敗しました",
  "スーパー管理者専用・メールワーカーキュー送信",
  "スタンプ",
  "スタンプ完了",
  "スタンプ完了ユーザー",
  "承認済みアカウントを確認",
  "承認済み管理者アカウント専用",
  "承認済み管理者アカウントでログインし、運用ダッシュボードと管理機能をご利用ください。",
  "承認された範囲の運用機能を利用します。",
  "試行",
  "実際のワーカーテンプレート基準",
  "下のリンクをコピーしてください。",
  "アバター報酬イベントポップアップURLを適用",
  "アバター報酬イベントのポップアップを開くには、移動先URLに次を入力してください：",
  "ID",
  "ID、ニックネーム、パスワードは必須です。二次パスワードは必要な場合のみ入力してください。",
  "ID、ニックネーム、メール、パスワード",
  "英字、数字、アンダースコアを使って4～20文字で入力してください。",
  "まだアカウントをお持ちでないですか？",
  "送信履歴はまだありません。",
  "変換履歴はまだありません。",
  "付与履歴はまだありません。",
  "安全な管理サービス",
  "規約への同意",
  "に送信します。",
  "エージェント登録状況",
  "エージェント階層、所属ユーザー、手数料、資産、ミッション賞金ポリシーを管理します。",
  "エージェント一覧を読み込めませんでした。",
  "エージェント追加賞金を支給しない",
  "エージェントコード",
  "複数エージェントに分配",
  "英字、数字、特殊文字の組み合わせを推奨します。",
  "英字・数字4～20文字",
  "例：サイトへ移動",
  "予想送信数",
  "本日の組織登録者",
  "リクエストが多すぎます。しばらくしてから再試行してください。",
  "優先順位",
  "ユーザー検索",
  "ユーザー検索に失敗しました。",
  "ユーザーコード",
  "ユーザーコード、ID、ニックネーム",
  "ユーザーコード、ID、ニックネーム、所属エージェントを検索",
  "この設定はユーザーテーブルの賞金には影響せず、agent_shareで計算された追加賞金の受益者のみを決定します。",
  "メール",
  "メール管理情報を読み込み中...",
  "メール管理情報を読み込めませんでした。",
  "メールマーケティング情報を受信",
  "メール送信",
  "メール送信リクエストに失敗しました。",
  "メール件名プレビュー",
  "このメールを送信しますか？\n\n対象：{target}\n件名：{subject}\n予想送信数：{count}件",
  "メールが送信キューに登録されました。",
  "すでにアカウントをお持ちですか？",
  "このメールアドレスはすでに登録されています。",
  "このIDはすでに使用されています。",
  "利用目的",
  "利用規約に同意",
  "利用規約への同意",
  "利用規約と個人情報の収集・利用に同意してください。",
  "認証済みメールあり",
  "認証済みメールがないユーザーには送信できません。",
  "認証済みメールがあり、マーケティングメールに同意し、ブロックされていないユーザー",
  "認証済み",
  "日時",
  "入力情報は、アカウント作成、承認、本人確認、アカウント復旧の目的にのみ使用されます。退会または保有目的達成後は、法令で定める保管期間を除き破棄されます。",
  "自分の直属ユーザーとすべての下位エージェント所属ユーザーを合算して確認します。",
  "資産変換完了",
  "作成したメール本文がここに表示されます。",
  "再試行待ち",
  "付与",
  "が付与されます。",
  "専用登録URL",
  "すべて同意",
  "全送信対象",
  "アクセス記録保護",
  "アクセスを開始します。",
  "情報入力",
  "組織全体",
  "組織全体の登録者",
  "表示するエージェント",
  "直属",
  "直属登録者",
  "直属エージェントが全額受領",
  "処理時刻／エラー",
  "最近30日",
  "最近7日",
  "最近の資産変換",
  "最近のポイント付与",
  "最上位エージェントが全額受領",
  "各組織の紹介ユーザー報酬ポイントは",
  "紹介コード",
  "紹介コードまたはエージェントラインコード",
  "紹介コードを確認できません。",
  "ターゲット別情報ボタンの作成に失敗しました",
  "テスト受信メール",
  "テスト受信メールを入力してください。",
  "テーブルグループ精算ポリシー",
  "テーブルグループ精算ポリシーの保存に失敗しました",
  "指定エージェントが全額受領",
  "ポイントスタンプ",
  "ポイントの資産変換に失敗しました。",
  "ポイント状況は確認できますが、資産変換は該当するlv2エージェント本人のみ実行できます。",
  "ポイントが資産に変換されました。",
  "表示ニックネーム",
  "必須の個人情報収集に同意しない場合、登録は制限されます。",
  "必須項目と任意項目のすべてに同意します。",
  "必須規約とプライバシー案内を確認します。",
  "必須情報を入力し、個人情報の収集・利用案内を確認して登録を完了してください。",
  "必須確認",
  "下部案内",
  "下位",
  "下位登録者",
  "下位組織ユーザー",
  "下位エージェントまたは一般ユーザーアカウントを作成します。入力したアカウント情報は作成後すぐに反映されます。",
  "1行にagent_id:percentを入力してください。percentの合計は1または100である必要があります。",
  "項目を選択すると個別送信結果を確認できます。",
  "現在送信待ち",
  "この紹介コードは現在使用できません。",
  "現在の設定でターゲット項目を作成",
  "現在のエージェント配下に一般ユーザーを作成します。",
  "編集中：",
  "現在、登録は停止されています。",
  "有効",
  "会員識別、アカウント管理、本人確認、アカウント復旧",
  "会員識別とアカウント管理・復旧のため、ID、ニックネーム、メール、認証情報を処理し、利用目的達成後は関連法令に従って保管または破棄します。",
  "退会時まで、または法令で定める期間",
  "会員登録",
  "登録APIが見つかりません。",
  "登録リンクをコピーしました。",
  "会員登録とアカウント管理のため、以下の個人情報を収集します。内容を確認してから登録を進めてください。",
  "登録案内",
  "登録リクエストを処理できませんでした。",
  "登録リクエストは拒否されました。",
  "登録が完了しました。すぐにログインできます。",
  "登録リクエストが完了しました。承認済みアカウントはすぐにログインできます。",
  "登録処理中…"
];

const itValues = [
  "* Le immagini di sfondo possono essere caricate fino a 5 MB. È supportato anche l'inserimento diretto dell'URL.",
  "* Questo sfondo si applica solo al target dispositivo/lingua selezionato. Il paese non è attualmente usato e viene salvato come ALL. Per sfondi diversi su desktop/mobile o per lingua, crea un elemento target separato.",
  "/events/avatar-reward oppure https://...",
  "Inserisci almeno 8 caratteri",
  "Limite in unità BB. Inserisci 0 per nessun limite.",
  "Event Fee % deve essere compreso tra 0 e 100.",
  "Rake % deve essere compreso tra 0 e 100.",
  "Rake Cap BB deve essere almeno 0.",
  "Coda email Redis",
  "Riprova errori SMTP",
  "[Facoltativo]",
  "[Obbligatorio]",
  "all / Desktop + Mobile",
  "all / Tutte le lingue",
  "desktop / Desktop",
  "ko / Coreano",
  "Solo sull'account agente lv2",
  "Punti premio referral lv2",
  "mobile / Mobile",
  "Converti tutti i {amount} USDT in asset",
  "Convertire tutti i {amount} punti USDT negli asset dell'agente corrente?",
  "verranno accreditati. Ogni utente viene contrassegnato una sola volta.",
  "Nessun utente registrato.",
  "Impossibile caricare lo stato delle registrazioni.",
  "Dopo la registrazione puoi controllare lo stato di approvazione.",
  "Data di registrazione",
  "Ogni cella è un elemento pulsante informativo separato. Se non esiste, viene creato copiando le impostazioni correnti; se esiste, aprilo per modificare lo sfondo separatamente.",
  "Invio individuale disponibile",
  "Caricamento risultati degli invii individuali...",
  "Nessun record di invio individuale.",
  "Impossibile caricare la cronologia degli invii individuali.",
  "Consenso alla raccolta e all'uso dei dati personali",
  "Informativa sulla raccolta e l'uso dei dati personali",
  "Informativa sulla privacy",
  "Nessun risultato di ricerca.",
  "Ricerca in corso",
  "Per problemi con l'account contatta l'amministratore superiore",
  "Controlla lo stato dell'account e i permessi di accesso.",
  "Controlla il tipo di account e i dati obbligatori prima di crearlo. Il nuovo account viene collegato subito sotto l'agente corrente.",
  "Dati account",
  "Utilizzato per verificare e recuperare l'account.",
  "Inserisci correttamente i dati dell'account e di recupero.",
  "Gli account devono essere creati dal titolare o da una persona autorizzata. Condivisione, abuso dei permessi e interferenze con il servizio possono essere limitati.",
  "Non selezionare Mantieni l'accesso su un dispositivo condiviso.",
  "Accedi agli strumenti di amministrazione",
  "Per i servizi di amministrazione",
  "Questo nome viene visualizzato nell'interfaccia di amministrazione.",
  "Inserisci i dati dell'account amministratore.",
  "Informazioni sull'accesso amministratore",
  "Menu amministratore",
  "Apri menu amministratore",
  "Approvazione amministratore",
  "Solo gli account approvati da un amministratore possono accedere.",
  "Gli account che richiedono approvazione possono accedere dopo l'approvazione.",
  "Inserisci ID amministratore",
  "Accesso amministratore",
  "Home amministratore",
  "Verifica permessi",
  "Esistente",
  "Apri elemento target esistente",
  "Il mio account",
  "URL popup interno",
  "Target di visualizzazione / sfondo individuale",
  "Punti totali ottenuti",
  "Inserisci un nickname da 2 a 16 caratteri.",
  "Fino ai prossimi 20 USDT",
  "Utenti in attesa del prossimo premio",
  "In attesa",
  "Coda",
  "Aggiunta alla coda...",
  "Target",
  "Inserisci esattamente rispettando maiuscole e minuscole.",
  "Desktop",
  "Inserisci la stessa password.",
  "Nessuna email registrata",
  "Dispositivo",
  "Gestione rapida sfondi per dispositivo/lingua",
  "Gli accessi e le principali attività amministrative vengono registrati per sicurezza.",
  "Ricorda ID di accesso",
  "Accesso in corso…",
  "Torna all'accesso",
  "Vai all'accesso",
  "Questo è l'ID utilizzato per accedere.",
  "Ripetuti tentativi falliti possono bloccare temporaneamente l'account. Chiedi a un amministratore di verificarne lo stato.",
  "Inserisci",
  "Copia link",
  "Consenso marketing",
  "{count} utenti con consenso marketing",
  "Non ci sono utenti che hanno acconsentito alle email di marketing.",
  "Componi email",
  "Oggetto email",
  "Inserisci oggetto e corpo dell'email.",
  "utenti ciascuno",
  "Mobile",
  "Non creato",
  "Impostazioni beneficiario premio missione",
  "Non verificato",
  "Oggetto mostrato nella posta in arrivo",
  "Inserisci l'ID dell'account amministratore ricevuto.",
  "Inserisci l'ID amministratore ricevuto.",
  "Destinatari",
  "Anteprima invio",
  "Cronologia invii",
  "Inserisci il contenuto da inviare.",
  "Seleziona un utente destinatario.",
  "Nessuno sfondo",
  "Carica immagine di sfondo / URL",
  "Caricamento dello sfondo non riuscito (controlla l'API di upload del server)",
  "Carica un'immagine di sfondo non superiore a 5 MB.",
  "Batch",
  "URL pulsante",
  "Testo pulsante",
  "Converti",
  "Conversione...",
  "Asset dopo la conversione",
  "Visualizza",
  "Avviso di sicurezza",
  "Periodo di conservazione",
  "Protetto",
  "Questa email è stata inviata da Night Poker Club.",
  "Titolo del corpo",
  "Formula di distribuzione",
  "La formula deve usare agent_id:percent e la somma delle percentuali deve essere 1 o 100. Esempio: 1002:0.7 / 1001:0.3",
  "Reinserisci password",
  "Inserisci password",
  "Conferma password",
  "Le password non corrispondono.",
  "Inserisci una password di almeno 8 caratteri.",
  "Usa una password diversa dagli altri servizi.",
  "Lascia vuoto per usare l'oggetto dell'email",
  "Punti disponibili",
  "Inserisci un indirizzo email valido.",
  "Beneficiario del premio",
  "Agente superiore: {id}",
  "L'agente superiore riceve tutto",
  "Crea un nuovo account.",
  "Inserisci le informazioni di base necessarie per usare il servizio.",
  "Seleziona",
  "Operazione riuscita",
  "Agente assegnato",
  "Consenso dato",
  "Consenso non dato",
  "Destinatario",
  "Dati raccolti",
  "Metodo beneficiario",
  "agent_id beneficiario",
  "Inserisci l'agent_id del beneficiario.",
  "Salvataggio impostazioni beneficiario non riuscito",
  "Solo superadmin · Invio tramite coda del worker email",
  "Timbro",
  "Timbro completato",
  "Utenti timbrati",
  "Verifica account approvato",
  "Solo account amministratore approvati",
  "Accedi con un account amministratore approvato per usare dashboard operativa e funzioni di gestione.",
  "Usa le funzioni operative entro l'ambito approvato.",
  "Tentativo",
  "Basato sul modello reale del worker",
  "Copia il link qui sotto.",
  "Applica URL popup evento premio avatar",
  "Per aprire il popup dell'evento premio avatar, inserisci nell'URL di destinazione:",
  "ID",
  "ID, nickname e password sono obbligatori. Inserisci una password secondaria solo se necessario.",
  "ID, nickname, email e password",
  "Inserisci 4–20 caratteri usando lettere, numeri e underscore.",
  "Non hai ancora un account?",
  "Nessuna cronologia di invio.",
  "Nessuna cronologia di conversione.",
  "Nessuna cronologia di accredito.",
  "Servizio di amministrazione sicuro",
  "Consenso ai termini",
  "riceverà questo messaggio.",
  "Stato registrazione agenti",
  "Gestisci gerarchia agenti, utenti assegnati, commissioni, asset e politiche dei premi missione.",
  "Impossibile caricare l'elenco agenti.",
  "Non pagare il premio aggiuntivo all'agente",
  "Codice agente",
  "Distribuisci tra più agenti",
  "È consigliata una combinazione di lettere, numeri e caratteri speciali.",
  "4–20 lettere e numeri",
  "Esempio: Vai al sito",
  "Invii stimati",
  "Registrazioni organizzazione oggi",
  "Troppe richieste. Riprova più tardi.",
  "Priorità",
  "Cerca utente",
  "Ricerca utente non riuscita.",
  "Codice utente",
  "Codice utente, ID, nickname",
  "Cerca codice utente, ID, nickname o agente assegnato",
  "Questa impostazione non modifica i premi dei tavoli utente; determina solo i beneficiari del premio aggiuntivo calcolato da agent_share.",
  "Email",
  "Caricamento informazioni gestione email...",
  "Impossibile caricare le informazioni di gestione email.",
  "Ricevi informazioni marketing via email",
  "Invia email",
  "Richiesta di invio email non riuscita.",
  "Anteprima oggetto email",
  "Inviare questa email?\n\nTarget: {target}\nOggetto: {subject}\nInvii stimati: {count}",
  "L'email è stata aggiunta alla coda di invio.",
  "Hai già un account?",
  "Questa email è già registrata.",
  "Questo ID è già in uso.",
  "Finalità d'uso",
  "Accetta i Termini di servizio",
  "Consenso ai Termini di servizio",
  "Accetta i Termini di servizio e la raccolta e l'uso dei dati personali.",
  "Email verificata disponibile",
  "Non è possibile inviare a un utente senza email verificata.",
  "Utenti con email verificata, consenso marketing e non bloccati",
  "Verificato",
  "Data e ora",
  "Le informazioni inserite sono trattate solo per creazione e approvazione dell'account, verifica dell'identità e recupero. Sono eliminate dopo il recesso o il raggiungimento della finalità, salvo i periodi previsti dalla legge.",
  "Visualizza il totale combinato degli utenti diretti e degli utenti di tutti gli agenti a valle.",
  "Conversione asset completata",
  "Il corpo dell'email scritto apparirà qui.",
  "In attesa di riprovare",
  "Accredito",
  "verrà accreditato.",
  "URL di registrazione dedicato",
  "Accetta tutto",
  "Tutti i destinatari",
  "Protezione registro accessi",
  "Avvia accesso.",
  "Inserisci informazioni",
  "Intera organizzazione",
  "Registrazioni totali organizzazione",
  "Agente da visualizzare",
  "Diretti",
  "Registrazioni dirette",
  "L'agente diretto riceve tutto",
  "Ora elaborazione / Errore",
  "Ultimi 30 giorni",
  "Ultimi 7 giorni",
  "Conversioni asset recenti",
  "Accrediti punti recenti",
  "L'agente di livello più alto riceve tutto",
  "I punti premio degli utenti referral di ogni organizzazione vengono accreditati",
  "Codice referral",
  "Codice referral o codice linea agente",
  "Impossibile verificare il codice referral.",
  "Creazione pulsante informativo per il target non riuscita",
  "Email destinatario di prova",
  "Inserisci l'email destinatario di prova.",
  "Politica di regolamento gruppo tavoli",
  "Salvataggio della politica di regolamento non riuscito",
  "L'agente specificato riceve tutto",
  "Timbro punti",
  "Conversione punti in asset non riuscita.",
  "Lo stato dei punti è visibile, ma solo l'agente lv2 interessato può convertirli in asset.",
  "I punti sono stati convertiti in asset.",
  "Nickname visualizzato",
  "La registrazione è limitata senza il consenso alla raccolta obbligatoria dei dati personali.",
  "Accetta tutti gli elementi obbligatori e facoltativi.",
  "Controlla i termini obbligatori e l'informativa sulla privacy.",
  "Inserisci i dati obbligatori, leggi l'informativa sulla raccolta e l'uso dei dati personali e completa la registrazione.",
  "Conferma obbligatoria",
  "Avviso a piè di pagina",
  "A valle",
  "Registrazioni a valle",
  "Utenti dell'organizzazione a valle",
  "Crea un agente subordinato o un account utente normale. I dati inseriti diventano effettivi subito dopo la creazione.",
  "Inserisci un agent_id:percent per riga. La somma delle percentuali deve essere 1 o 100.",
  "Seleziona un elemento per vedere i risultati degli invii individuali.",
  "Attualmente in attesa di invio",
  "Questo codice referral non è attualmente disponibile.",
  "Crea elemento target dalle impostazioni correnti",
  "Crea un utente normale sotto l'agente corrente.",
  "Modifica corrente:",
  "Le registrazioni sono attualmente sospese.",
  "Attivo",
  "Identificazione membro, gestione account, verifica identità e recupero account",
  "Per identificazione e gestione/recupero dell'account trattiamo ID, nickname, email e dati di verifica, poi li conserviamo o eliminiamo secondo la legge dopo il raggiungimento della finalità.",
  "Fino alla chiusura dell'account o per il periodo previsto dalla legge",
  "Registrati",
  "API di registrazione non trovata.",
  "Link di registrazione copiato.",
  "Raccogliamo i dati personali seguenti per registrazione e gestione account. Leggili prima di procedere.",
  "Informazioni sulla registrazione",
  "Impossibile elaborare la richiesta di registrazione.",
  "La richiesta di registrazione è stata rifiutata.",
  "Registrazione completata. Puoi accedere subito.",
  "La richiesta di registrazione è stata completata. Gli account approvati possono accedere subito.",
  "Registrazione in corso…"
];

const frValues = [
  "* Les images d’arrière-plan peuvent être téléversées jusqu’à 5 Mo. La saisie directe d’une URL reste également disponible.",
  "* Cet arrière-plan s’applique uniquement à la cible appareil/langue sélectionnée. Le pays n’est pas utilisé actuellement et est enregistré comme ALL. Pour des arrière-plans différents selon desktop/mobile ou la langue, créez un élément cible distinct.",
  "/events/avatar-reward ou https://...",
  "Saisissez au moins 8 caractères",
  "Plafond en unités BB. Saisissez 0 pour aucun plafond.",
  "Event Fee % doit être compris entre 0 et 100.",
  "Rake % doit être compris entre 0 et 100.",
  "Rake Cap BB doit être supérieur ou égal à 0.",
  "File d’e-mails Redis",
  "Réessayer les échecs SMTP",
  "[Facultatif]",
  "[Obligatoire]",
  "all / Bureau + Mobile",
  "all / Toutes les langues",
  "desktop / Bureau",
  "ko / Coréen",
  "Uniquement sur le compte agent lv2",
  "Points de récompense de parrainage lv2",
  "mobile / Mobile",
  "Convertir la totalité des {amount} USDT en actifs",
  "Convertir tous les {amount} points USDT en actifs de l’agent actuel ?",
  "seront crédités. Chaque utilisateur n’est tamponné qu’une seule fois.",
  "Aucun utilisateur inscrit.",
  "Impossible de charger l’état des inscriptions.",
  "Vous pourrez vérifier le statut d’approbation après l’inscription.",
  "Date d’inscription",
  "Chaque cellule est un élément de bouton d’information distinct. S’il n’existe pas, il est créé en copiant les réglages actuels ; s’il existe, ouvrez-le pour modifier son arrière-plan séparément.",
  "Envoi individuel disponible",
  "Chargement des résultats d’envoi individuel...",
  "Aucun historique d’envoi individuel.",
  "Impossible de charger l’historique des envois individuels.",
  "Consentement à la collecte et à l’utilisation des données personnelles",
  "Avis sur la collecte et l’utilisation des données personnelles",
  "Avis de confidentialité",
  "Aucun résultat de recherche.",
  "Recherche en cours",
  "Pour les problèmes de compte, contactez l’administrateur supérieur",
  "Vérifiez l’état du compte et les autorisations d’accès.",
  "Vérifiez le type de compte et les informations obligatoires avant de le créer. Le nouveau compte est immédiatement rattaché à l’agent actuel.",
  "Informations du compte",
  "Utilisé pour vérifier et récupérer le compte.",
  "Saisissez précisément les informations du compte et de récupération.",
  "Les comptes doivent être créés par leur titulaire ou une personne autorisée. Le partage de compte, l’abus d’autorisations et la perturbation du service peuvent être restreints.",
  "Ne sélectionnez pas le maintien de connexion sur un appareil partagé.",
  "Accéder aux outils d’administration",
  "Pour les services d’administration",
  "Ce nom est affiché dans l’interface d’administration.",
  "Saisissez les informations du compte administrateur.",
  "Informations de connexion administrateur",
  "Menu administrateur",
  "Ouvrir le menu administrateur",
  "Approbation administrateur",
  "Seuls les comptes approuvés par un administrateur peuvent accéder au service.",
  "Les comptes nécessitant une approbation pourront se connecter une fois celle-ci terminée.",
  "Saisissez l’ID administrateur",
  "Connexion administrateur",
  "Accueil administrateur",
  "Vérification des autorisations",
  "Existant",
  "Ouvrir l’élément cible existant",
  "Mon compte",
  "URL de fenêtre interne",
  "Cible d’affichage / arrière-plan individuel",
  "Total des points obtenus",
  "Saisissez un pseudonyme de 2 à 16 caractères.",
  "Jusqu’aux prochains 20 USDT",
  "Utilisateurs en attente de la prochaine récompense",
  "En attente",
  "File",
  "Ajout à la file...",
  "Cible",
  "Saisissez exactement en respectant la casse.",
  "Bureau",
  "Saisissez le même mot de passe.",
  "Aucun e-mail enregistré",
  "Appareil",
  "Gestion rapide des arrière-plans par appareil/langue",
  "Les connexions et principales activités d’administration sont enregistrées à des fins de sécurité.",
  "Mémoriser l’ID de connexion",
  "Connexion…",
  "Retour à la connexion",
  "Aller à la connexion",
  "Il s’agit de l’ID utilisé pour se connecter.",
  "Des échecs de connexion répétés peuvent verrouiller temporairement le compte. Demandez à un administrateur de vérifier son état.",
  "Saisissez",
  "Copier le lien",
  "Consentement marketing",
  "{count} utilisateurs ayant consenti au marketing",
  "Aucun utilisateur n’a consenti aux e-mails marketing.",
  "Rédiger un e-mail",
  "Objet de l’e-mail",
  "Saisissez l’objet et le corps de l’e-mail.",
  "utilisateurs chacun",
  "Mobile",
  "Non créé",
  "Paramètres du bénéficiaire du prix de mission",
  "Non vérifié",
  "Objet affiché dans la boîte de réception",
  "Saisissez l’ID du compte administrateur qui vous a été attribué.",
  "Saisissez l’ID administrateur qui vous a été attribué.",
  "Destinataires",
  "Aperçu de l’envoi",
  "Historique des envois",
  "Saisissez le contenu à envoyer.",
  "Sélectionnez l’utilisateur destinataire.",
  "Aucun arrière-plan",
  "Téléverser l’image d’arrière-plan / URL",
  "Échec du téléversement de l’arrière-plan (vérifiez l’API de téléversement du serveur)",
  "Téléversez une image d’arrière-plan de 5 Mo maximum.",
  "Lot",
  "URL du bouton",
  "Libellé du bouton",
  "Convertir",
  "Conversion...",
  "Actifs après conversion",
  "Voir",
  "Avis de sécurité",
  "Durée de conservation",
  "Protégé",
  "Cet e-mail a été envoyé par Night Poker Club.",
  "Titre du corps",
  "Formule de répartition",
  "La formule doit utiliser agent_id:percent et la somme des pourcentages doit être égale à 1 ou 100. Exemple : 1002:0.7 / 1001:0.3",
  "Saisissez à nouveau le mot de passe",
  "Saisissez le mot de passe",
  "Confirmez le mot de passe",
  "La confirmation du mot de passe ne correspond pas.",
  "Saisissez un mot de passe d’au moins 8 caractères.",
  "Utilisez un mot de passe différent de ceux de vos autres services.",
  "Laissez vide pour utiliser l’objet de l’e-mail",
  "Points disponibles",
  "Saisissez une adresse e-mail valide.",
  "Bénéficiaire du prix",
  "Agent supérieur : {id}",
  "L’agent supérieur reçoit tout",
  "Créer un nouveau compte.",
  "Saisissez les informations de base nécessaires à l’utilisation du service.",
  "Sélectionner",
  "Réussi",
  "Agent rattaché",
  "Consentement donné",
  "Consentement non donné",
  "Destinataire",
  "Données collectées",
  "Mode de bénéficiaire",
  "agent_id du bénéficiaire",
  "Saisissez l’agent_id du bénéficiaire.",
  "Échec de l’enregistrement des paramètres du bénéficiaire",
  "Superadmin uniquement · Envoi via la file du worker e-mail",
  "Tampon",
  "Tampon effectué",
  "Utilisateurs tamponnés",
  "Vérifier le compte approuvé",
  "Réservé aux comptes administrateur approuvés",
  "Connectez-vous avec un compte administrateur approuvé pour utiliser le tableau de bord opérationnel et les fonctions de gestion.",
  "Utilisez les fonctions opérationnelles dans le périmètre approuvé.",
  "Tentative",
  "Basé sur le modèle réel du worker",
  "Copiez le lien ci-dessous.",
  "Appliquer l’URL de la fenêtre de l’événement de récompense avatar",
  "Pour ouvrir la fenêtre de l’événement de récompense avatar, saisissez ceci dans l’URL de destination :",
  "ID",
  "L’ID, le pseudonyme et le mot de passe sont obligatoires. Saisissez un mot de passe secondaire uniquement si nécessaire.",
  "ID, pseudonyme, e-mail et mot de passe",
  "Saisissez 4 à 20 caractères avec des lettres, des chiffres et des traits de soulignement.",
  "Vous n’avez pas encore de compte ?",
  "Aucun historique d’envoi pour le moment.",
  "Aucun historique de conversion pour le moment.",
  "Aucun historique de crédit pour le moment.",
  "Service d’administration sécurisé",
  "Consentement aux conditions",
  "recevra ce message.",
  "État des inscriptions d’agents",
  "Gérez la hiérarchie des agents, les utilisateurs rattachés, les frais, les actifs et les politiques de prix de mission.",
  "Impossible de charger la liste des agents.",
  "Ne pas verser le prix supplémentaire à l’agent",
  "Code agent",
  "Répartir entre plusieurs agents",
  "Une combinaison de lettres, chiffres et caractères spéciaux est recommandée.",
  "4 à 20 lettres et chiffres",
  "Exemple : Accéder au site",
  "Envois estimés",
  "Inscriptions de l’organisation aujourd’hui",
  "Trop de requêtes. Réessayez plus tard.",
  "Priorité",
  "Recherche d’utilisateur",
  "Échec de la recherche d’utilisateur.",
  "Code utilisateur",
  "Code utilisateur, ID, pseudonyme",
  "Rechercher par code utilisateur, ID, pseudonyme ou agent rattaché",
  "Ce paramètre n’affecte pas les prix des tables utilisateur ; il détermine uniquement les bénéficiaires du prix supplémentaire calculé avec agent_share.",
  "E-mail",
  "Chargement des informations de gestion des e-mails...",
  "Impossible de charger les informations de gestion des e-mails.",
  "Recevoir les informations marketing par e-mail",
  "Envoyer un e-mail",
  "Échec de la demande d’envoi d’e-mail.",
  "Aperçu de l’objet de l’e-mail",
  "Envoyer cet e-mail ?\n\nCible : {target}\nObjet : {subject}\nEnvois estimés : {count}",
  "L’e-mail a été ajouté à la file d’envoi.",
  "Vous avez déjà un compte ?",
  "Cette adresse e-mail est déjà enregistrée.",
  "Cet ID est déjà utilisé.",
  "Finalité d’utilisation",
  "Accepter les Conditions d’utilisation",
  "Consentement aux Conditions d’utilisation",
  "Acceptez les Conditions d’utilisation ainsi que la collecte et l’utilisation des données personnelles.",
  "Possède un e-mail vérifié",
  "Impossible d’envoyer à un utilisateur sans adresse e-mail vérifiée.",
  "Utilisateurs avec e-mail vérifié, consentement marketing et non bloqués",
  "Vérifié",
  "Date et heure",
  "Les informations saisies sont traitées uniquement pour la création et l’approbation du compte, la vérification de l’identité et la récupération du compte. Elles sont supprimées après le retrait ou l’accomplissement de la finalité, hors durées légales de conservation.",
  "Affichez le total combiné de vos utilisateurs directs et des utilisateurs rattachés à tous les agents en aval.",
  "Conversion des actifs terminée",
  "Le corps de l’e-mail que vous rédigez apparaîtra ici.",
  "En attente d’une nouvelle tentative",
  "Crédit",
  "sera crédité.",
  "URL d’inscription dédiée",
  "Tout accepter",
  "Tous les destinataires",
  "Protection du journal d’accès",
  "Démarrer l’accès.",
  "Saisir les informations",
  "Organisation entière",
  "Total des inscriptions de l’organisation",
  "Agent à consulter",
  "Direct",
  "Inscriptions directes",
  "L’agent direct reçoit tout",
  "Heure de traitement / Erreur",
  "30 derniers jours",
  "7 derniers jours",
  "Conversions d’actifs récentes",
  "Crédits de points récents",
  "L’agent de niveau supérieur reçoit tout",
  "Les points de récompense des utilisateurs parrainés de chaque organisation sont crédités",
  "Code de parrainage",
  "Code de parrainage ou code de ligne d’agent",
  "Impossible de vérifier le code de parrainage.",
  "Échec de la création du bouton d’information pour la cible",
  "E-mail de test destinataire",
  "Saisissez l’e-mail de test destinataire.",
  "Politique de règlement du groupe de tables",
  "Échec de l’enregistrement de la politique de règlement du groupe de tables",
  "L’agent spécifié reçoit tout",
  "Tampon de points",
  "Échec de la conversion des points en actifs.",
  "L’état des points peut être consulté, mais seul l’agent lv2 concerné peut les convertir en actifs.",
  "Les points ont été convertis en actifs.",
  "Pseudonyme affiché",
  "L’inscription est limitée sans consentement à la collecte obligatoire des données personnelles.",
  "Accepter tous les éléments obligatoires et facultatifs.",
  "Consultez les conditions obligatoires et l’avis de confidentialité.",
  "Saisissez les informations obligatoires, consultez l’avis de collecte et d’utilisation des données personnelles, puis terminez l’inscription.",
  "Confirmation obligatoire",
  "Avis de pied de page",
  "En aval",
  "Inscriptions en aval",
  "Utilisateurs de l’organisation en aval",
  "Créez un agent subordonné ou un compte utilisateur normal. Les informations saisies prennent effet immédiatement après la création.",
  "Saisissez un agent_id:percent par ligne. La somme des pourcentages doit être égale à 1 ou 100.",
  "Sélectionnez un élément pour consulter les résultats d’envoi individuel.",
  "Actuellement en attente d’envoi",
  "Ce code de parrainage est actuellement indisponible.",
  "Créer un élément cible à partir des paramètres actuels",
  "Créer un utilisateur normal sous l’agent actuel.",
  "Modification en cours :",
  "Les inscriptions sont actuellement suspendues.",
  "Actif",
  "Identification du membre, gestion du compte, vérification d’identité et récupération du compte",
  "Pour l’identification et la gestion/récupération du compte, nous traitons l’ID, le pseudonyme, l’e-mail et les informations de vérification, puis les conservons ou les supprimons conformément à la loi après réalisation de la finalité.",
  "Jusqu’à la fermeture du compte ou pendant la durée prévue par la loi",
  "S’inscrire",
  "API d’inscription introuvable.",
  "Lien d’inscription copié.",
  "Nous collectons les données personnelles ci-dessous pour l’inscription et la gestion du compte. Consultez-les avant de continuer.",
  "Informations sur l’inscription",
  "Impossible de traiter la demande d’inscription.",
  "La demande d’inscription a été refusée.",
  "L’inscription est terminée. Vous pouvez vous connecter immédiatement.",
  "La demande d’inscription est terminée. Les comptes approuvés peuvent se connecter immédiatement.",
  "Traitement de l’inscription…"
];

const hiValues = [
  "* बैकग्राउंड इमेज अधिकतम 5 MB तक अपलोड की जा सकती है। सीधे URL दर्ज करना भी समर्थित है।",
  "* यह बैकग्राउंड केवल चुने गए डिवाइस/भाषा लक्ष्य पर लागू होता है। देश का मान अभी उपयोग नहीं होता और ALL के रूप में सेव होता है। desktop/mobile या भाषा के अनुसार अलग बैकग्राउंड के लिए अलग लक्ष्य आइटम बनाएं।",
  "/events/avatar-reward या https://...",
  "कम से कम 8 अक्षर दर्ज करें",
  "BB इकाई में सीमा। सीमा न रखने के लिए 0 दर्ज करें।",
  "Event Fee % 0 से 100 के बीच होना चाहिए।",
  "Rake % 0 से 100 के बीच होना चाहिए।",
  "Rake Cap BB 0 या उससे अधिक होना चाहिए।",
  "Redis ईमेल कतार",
  "SMTP विफलताओं को फिर आज़माएं",
  "[वैकल्पिक]",
  "[आवश्यक]",
  "all / डेस्कटॉप + मोबाइल",
  "all / सभी भाषाएं",
  "desktop / डेस्कटॉप",
  "ko / कोरियाई",
  "केवल lv2 एजेंट खाते में",
  "lv2 रेफरल इनाम अंक",
  "mobile / मोबाइल",
  "पूरे {amount} USDT को एसेट में बदलें",
  "क्या पूरे {amount} USDT अंकों को वर्तमान एजेंट के एसेट में बदलना है?",
  "जमा किए जाएंगे। प्रत्येक उपयोगकर्ता पर केवल एक बार स्टैम्प लगेगा।",
  "कोई पंजीकृत उपयोगकर्ता नहीं है।",
  "पंजीकरण स्थिति लोड नहीं हो सकी।",
  "पंजीकरण के बाद स्वीकृति की स्थिति देख सकते हैं।",
  "पंजीकरण तिथि",
  "हर सेल एक अलग सूचना-बटन आइटम है। न होने पर वर्तमान सेटिंग की प्रति बनाकर बनाया जाएगा; होने पर उसे खोलकर बैकग्राउंड अलग से बदल सकते हैं।",
  "व्यक्तिगत भेजना उपलब्ध",
  "व्यक्तिगत भेजने के परिणाम लोड हो रहे हैं...",
  "व्यक्तिगत भेजने का कोई रिकॉर्ड नहीं है।",
  "व्यक्तिगत भेजने का इतिहास लोड नहीं हो सका।",
  "व्यक्तिगत जानकारी के संग्रह और उपयोग की सहमति",
  "व्यक्तिगत जानकारी के संग्रह और उपयोग की सूचना",
  "गोपनीयता सूचना",
  "कोई खोज परिणाम नहीं मिला।",
  "खोज जारी है",
  "खाते की समस्या के लिए वरिष्ठ प्रशासक से संपर्क करें",
  "खाते की स्थिति और प्रवेश अनुमतियां जांचें।",
  "बनाने से पहले खाता प्रकार और आवश्यक जानकारी जांचें। नया खाता तुरंत वर्तमान एजेंट के अंतर्गत जुड़ जाएगा।",
  "खाता जानकारी",
  "खाता सत्यापन और पुनर्प्राप्ति के लिए उपयोग होता है।",
  "खाता और पुनर्प्राप्ति जानकारी सही-सही दर्ज करें।",
  "खाता मालिक या अधिकृत व्यक्ति द्वारा बनाया जाना चाहिए। खाता साझा करना, अनुमति का दुरुपयोग और सेवा संचालन में बाधा सीमित की जा सकती है।",
  "साझा डिवाइस पर साइन-इन बनाए रखने का विकल्प न चुनें।",
  "प्रशासन टूल खोलें",
  "प्रशासन सेवा के लिए",
  "यह नाम प्रशासन स्क्रीन पर दिखाया जाएगा।",
  "प्रशासक खाते की जानकारी दर्ज करें।",
  "प्रशासक लॉगिन सूचना",
  "प्रशासक मेनू",
  "प्रशासक मेनू खोलें",
  "प्रशासक स्वीकृति",
  "केवल प्रशासक द्वारा स्वीकृत खाते प्रवेश कर सकते हैं।",
  "जिन खातों को स्वीकृति चाहिए वे स्वीकृति पूरी होने के बाद लॉगिन कर सकते हैं।",
  "प्रशासक ID दर्ज करें",
  "प्रशासक लॉगिन",
  "प्रशासक होम",
  "अनुमति जांच",
  "मौजूदा",
  "मौजूदा लक्ष्य आइटम खोलें",
  "मेरा खाता",
  "आंतरिक पॉपअप URL",
  "प्रदर्शन लक्ष्य / अलग बैकग्राउंड",
  "कुल प्राप्त अंक",
  "2 से 16 अक्षरों का निकनेम दर्ज करें।",
  "अगले 20 USDT तक",
  "अगले इनाम की प्रतीक्षा में उपयोगकर्ता",
  "लंबित",
  "कतार",
  "कतार में जोड़ा जा रहा है...",
  "लक्ष्य",
  "अक्षरों के केस सहित बिल्कुल सही दर्ज करें।",
  "डेस्कटॉप",
  "वही पासवर्ड दोबारा दर्ज करें।",
  "कोई पंजीकृत ईमेल नहीं",
  "डिवाइस",
  "डिवाइस/भाषा के अनुसार त्वरित बैकग्राउंड प्रबंधन",
  "सुरक्षा के लिए लॉगिन और प्रमुख प्रशासन गतिविधियां दर्ज की जाती हैं।",
  "लॉगिन ID याद रखें",
  "लॉगिन हो रहा है…",
  "लॉगिन पर वापस जाएं",
  "लॉगिन स्क्रीन पर जाएं",
  "यह लॉगिन में उपयोग होने वाला ID है।",
  "बार-बार असफल लॉगिन से खाता अस्थायी रूप से लॉक हो सकता है। प्रशासक से स्थिति जांचने को कहें।",
  "दर्ज करें",
  "लिंक कॉपी करें",
  "मार्केटिंग सहमति",
  "मार्केटिंग सहमति वाले {count} उपयोगकर्ता",
  "मार्केटिंग ईमेल के लिए सहमत कोई उपयोगकर्ता नहीं है।",
  "ईमेल लिखें",
  "ईमेल विषय",
  "ईमेल का विषय और संदेश दर्ज करें।",
  "उपयोगकर्ता प्रति",
  "मोबाइल",
  "नहीं बनाया गया",
  "मिशन पुरस्कार लाभार्थी सेटिंग",
  "असत्यापित",
  "इनबॉक्स में दिखने वाला विषय",
  "जारी किया गया प्रशासक खाता ID दर्ज करें।",
  "जारी किया गया प्रशासक ID दर्ज करें।",
  "प्राप्तकर्ता",
  "भेजने का पूर्वावलोकन",
  "भेजने का इतिहास",
  "भेजने वाली सामग्री दर्ज करें।",
  "भेजने के लिए उपयोगकर्ता चुनें।",
  "कोई बैकग्राउंड नहीं",
  "बैकग्राउंड इमेज अपलोड / URL",
  "बैकग्राउंड इमेज अपलोड विफल (सर्वर अपलोड API जांचें)",
  "5 MB या उससे कम की बैकग्राउंड इमेज अपलोड करें।",
  "बैच",
  "बटन URL",
  "बटन टेक्स्ट",
  "बदलें",
  "बदला जा रहा है...",
  "बदलने के बाद एसेट",
  "देखें",
  "सुरक्षा सूचना",
  "संग्रह अवधि",
  "सुरक्षित",
  "यह ईमेल Night Poker Club द्वारा भेजा गया है।",
  "संदेश शीर्षक",
  "वितरण सूत्र",
  "वितरण सूत्र agent_id:percent रूप में होना चाहिए और percent का कुल 1 या 100 होना चाहिए। उदाहरण: 1002:0.7 / 1001:0.3",
  "पासवर्ड फिर दर्ज करें",
  "पासवर्ड दर्ज करें",
  "पासवर्ड की पुष्टि करें",
  "पासवर्ड की पुष्टि मेल नहीं खाती।",
  "कम से कम 8 अक्षरों का पासवर्ड दर्ज करें।",
  "अन्य सेवाओं से अलग पासवर्ड रखें।",
  "ईमेल विषय उपयोग करने के लिए खाली छोड़ें",
  "उपलब्ध अंक",
  "मान्य ईमेल पता दर्ज करें।",
  "पुरस्कार लाभार्थी",
  "वरिष्ठ एजेंट: {id}",
  "वरिष्ठ एजेंट पूरा प्राप्त करेगा",
  "नया खाता बनाएं।",
  "सेवा उपयोग के लिए आवश्यक मूल जानकारी दर्ज करें।",
  "चुनें",
  "सफल",
  "संबद्ध एजेंट",
  "सहमति दी",
  "सहमति नहीं दी",
  "प्राप्तकर्ता",
  "एकत्रित जानकारी",
  "लाभार्थी तरीका",
  "लाभार्थी agent_id",
  "लाभार्थी agent_id दर्ज करें।",
  "लाभार्थी सेटिंग सेव नहीं हुई",
  "केवल सुपरएडमिन · ईमेल वर्कर कतार से भेजें",
  "स्टैम्प",
  "स्टैम्प पूरा",
  "स्टैम्प किए उपयोगकर्ता",
  "स्वीकृत खाता जांचें",
  "केवल स्वीकृत प्रशासक खाते",
  "संचालन डैशबोर्ड और प्रबंधन सुविधाओं के लिए स्वीकृत प्रशासक खाते से लॉगिन करें।",
  "स्वीकृत दायरे में संचालन सुविधाओं का उपयोग करें।",
  "प्रयास",
  "वास्तविक वर्कर टेम्पलेट के आधार पर",
  "नीचे दिया लिंक कॉपी करें।",
  "अवतार इनाम इवेंट पॉपअप URL लागू करें",
  "अवतार इनाम इवेंट पॉपअप खोलने के लिए गंतव्य URL में यह दर्ज करें:",
  "ID",
  "ID, निकनेम और पासवर्ड आवश्यक हैं। द्वितीयक पासवर्ड केवल जरूरत पर दर्ज करें।",
  "ID, निकनेम, ईमेल, पासवर्ड",
  "अंग्रेजी अक्षर, अंक और अंडरस्कोर से 4–20 अक्षर दर्ज करें।",
  "अभी तक खाता नहीं है?",
  "अभी कोई भेजने का इतिहास नहीं है।",
  "अभी कोई रूपांतरण इतिहास नहीं है।",
  "अभी कोई अर्जन इतिहास नहीं है।",
  "सुरक्षित प्रशासन सेवा",
  "शर्तों की सहमति",
  "को यह संदेश भेजा जाएगा।",
  "एजेंट पंजीकरण स्थिति",
  "एजेंट संरचना, संबद्ध उपयोगकर्ता, शुल्क, एसेट और मिशन पुरस्कार नीतियां प्रबंधित करें।",
  "एजेंट सूची लोड नहीं हो सकी।",
  "अतिरिक्त एजेंट पुरस्कार न दें",
  "एजेंट कोड",
  "कई एजेंटों में बांटें",
  "अक्षर, अंक और विशेष चिन्हों का संयोजन सुझाया जाता है।",
  "4–20 अक्षर और अंक",
  "उदाहरण: वेबसाइट खोलें",
  "अनुमानित भेजे जाने वाले संदेश",
  "आज के संगठन पंजीकरण",
  "बहुत अधिक अनुरोध हैं। थोड़ी देर बाद फिर प्रयास करें।",
  "प्राथमिकता",
  "उपयोगकर्ता खोज",
  "उपयोगकर्ता खोज विफल हुई।",
  "उपयोगकर्ता कोड",
  "उपयोगकर्ता कोड, ID, निकनेम",
  "उपयोगकर्ता कोड, ID, निकनेम या संबद्ध एजेंट खोजें",
  "यह सेटिंग उपयोगकर्ता टेबल पुरस्कार को नहीं बदलती; यह केवल agent_share से गणना किए अतिरिक्त पुरस्कार के लाभार्थी तय करती है।",
  "ईमेल",
  "ईमेल प्रबंधन जानकारी लोड हो रही है...",
  "ईमेल प्रबंधन जानकारी लोड नहीं हो सकी।",
  "ईमेल मार्केटिंग जानकारी प्राप्त करें",
  "ईमेल भेजें",
  "ईमेल भेजने का अनुरोध विफल हुआ।",
  "ईमेल विषय पूर्वावलोकन",
  "यह ईमेल भेजें?\n\nलक्ष्य: {target}\nविषय: {subject}\nअनुमानित भेजे जाएंगे: {count}",
  "ईमेल भेजने की कतार में जोड़ दिया गया है।",
  "क्या पहले से खाता है?",
  "यह ईमेल पहले से पंजीकृत है।",
  "यह ID पहले से उपयोग में है।",
  "उपयोग का उद्देश्य",
  "सेवा की शर्तों से सहमत",
  "सेवा की शर्तों की सहमति",
  "सेवा की शर्तों तथा व्यक्तिगत जानकारी के संग्रह और उपयोग से सहमत हों।",
  "सत्यापित ईमेल मौजूद",
  "सत्यापित ईमेल के बिना उपयोगकर्ता को नहीं भेज सकते।",
  "सत्यापित ईमेल वाले, मार्केटिंग ईमेल से सहमत और ब्लॉक न किए गए उपयोगकर्ता",
  "सत्यापित",
  "दिनांक और समय",
  "दर्ज जानकारी केवल खाता निर्माण, स्वीकृति, पहचान सत्यापन और खाता पुनर्प्राप्ति के लिए संसाधित होती है। खाता बंद होने या उद्देश्य पूरा होने पर कानूनी संग्रह अवधि को छोड़कर इसे नष्ट कर दिया जाता है।",
  "अपने सीधे उपयोगकर्ताओं और सभी अधीनस्थ एजेंटों के उपयोगकर्ताओं का संयुक्त कुल देखें।",
  "एसेट रूपांतरण पूरा",
  "आपका लिखा ईमेल संदेश यहां दिखेगा।",
  "फिर प्रयास की प्रतीक्षा",
  "अर्जन",
  "जमा किया जाएगा।",
  "विशेष पंजीकरण URL",
  "सभी से सहमत",
  "सभी भेजने के लक्ष्य",
  "प्रवेश लॉग सुरक्षा",
  "प्रवेश शुरू करें।",
  "जानकारी दर्ज करें",
  "पूरा संगठन",
  "संगठन के कुल पंजीकरण",
  "देखने के लिए एजेंट",
  "प्रत्यक्ष",
  "प्रत्यक्ष पंजीकरण",
  "प्रत्यक्ष एजेंट पूरा प्राप्त करेगा",
  "प्रसंस्करण समय / त्रुटि",
  "पिछले 30 दिन",
  "पिछले 7 दिन",
  "हाल के एसेट रूपांतरण",
  "हाल के अंक अर्जन",
  "शीर्ष एजेंट पूरा प्राप्त करेगा",
  "हर संगठन के रेफरल उपयोगकर्ता इनाम अंक जमा किए जाते हैं",
  "रेफरल कोड",
  "रेफरल कोड या एजेंट लाइन कोड",
  "रेफरल कोड सत्यापित नहीं हो सका।",
  "लक्ष्य के लिए सूचना बटन नहीं बन सका",
  "परीक्षण प्राप्तकर्ता ईमेल",
  "परीक्षण प्राप्तकर्ता ईमेल दर्ज करें।",
  "टेबल समूह निपटान नीति",
  "टेबल समूह निपटान नीति सेव नहीं हुई",
  "निर्दिष्ट एजेंट पूरा प्राप्त करेगा",
  "अंक स्टैम्प",
  "अंकों को एसेट में बदलना विफल हुआ।",
  "अंकों की स्थिति देखी जा सकती है, लेकिन केवल संबंधित lv2 एजेंट ही उन्हें एसेट में बदल सकता है।",
  "अंक एसेट में बदल दिए गए हैं।",
  "दिखाया जाने वाला निकनेम",
  "आवश्यक व्यक्तिगत जानकारी के संग्रह की सहमति न देने पर पंजीकरण सीमित होगा।",
  "सभी आवश्यक और वैकल्पिक मदों से सहमत।",
  "आवश्यक शर्तें और गोपनीयता सूचना देखें।",
  "आवश्यक जानकारी दर्ज करें, व्यक्तिगत जानकारी संग्रह और उपयोग की सूचना देखें और पंजीकरण पूरा करें।",
  "आवश्यक पुष्टि",
  "फुटर सूचना",
  "अधीनस्थ",
  "अधीनस्थ पंजीकरण",
  "अधीनस्थ संगठन उपयोगकर्ता",
  "अधीनस्थ एजेंट या सामान्य उपयोगकर्ता खाता बनाएं। दर्ज जानकारी निर्माण के तुरंत बाद लागू होती है।",
  "हर पंक्ति में एक agent_id:percent दर्ज करें। percent का कुल 1 या 100 होना चाहिए।",
  "व्यक्तिगत भेजने के परिणाम देखने के लिए आइटम चुनें।",
  "अभी भेजने की प्रतीक्षा में",
  "यह रेफरल कोड अभी उपलब्ध नहीं है।",
  "वर्तमान सेटिंग से लक्ष्य आइटम बनाएं",
  "वर्तमान एजेंट के नीचे सामान्य उपयोगकर्ता बनाएं।",
  "अभी संपादन:",
  "पंजीकरण अभी निलंबित है।",
  "सक्रिय",
  "सदस्य पहचान, खाता प्रबंधन, पहचान सत्यापन और खाता पुनर्प्राप्ति",
  "सदस्य पहचान और खाता प्रबंधन/पुनर्प्राप्ति के लिए हम ID, निकनेम, ईमेल और सत्यापन जानकारी संसाधित करते हैं और उद्देश्य पूरा होने पर कानून के अनुसार रखते या हटाते हैं।",
  "खाता बंद होने तक या कानून द्वारा निर्धारित अवधि तक",
  "पंजीकरण करें",
  "पंजीकरण API नहीं मिला।",
  "पंजीकरण लिंक कॉपी किया गया।",
  "पंजीकरण और खाता प्रबंधन के लिए हम नीचे की व्यक्तिगत जानकारी एकत्र करते हैं। आगे बढ़ने से पहले इसे पढ़ें।",
  "पंजीकरण सूचना",
  "पंजीकरण अनुरोध संसाधित नहीं हो सका।",
  "पंजीकरण अनुरोध अस्वीकार कर दिया गया।",
  "पंजीकरण पूरा हो गया है। आप तुरंत साइन इन कर सकते हैं।",
  "पंजीकरण अनुरोध पूरा हो गया। स्वीकृत खाते तुरंत लॉगिन कर सकते हैं।",
  "पंजीकरण संसाधित हो रहा है…"
];

const urValues = [
  "* پس منظر کی تصویر زیادہ سے زیادہ 5 MB تک اپ لوڈ کی جا سکتی ہے۔ براہِ راست URL درج کرنا بھی دستیاب ہے۔",
  "* یہ پس منظر صرف منتخب ڈیوائس/زبان ہدف پر لاگو ہوتا ہے۔ ملک کی قدر فی الحال استعمال نہیں ہوتی اور ALL کے طور پر محفوظ ہوتی ہے۔ desktop/mobile یا زبان کے لحاظ سے الگ پس منظر کے لیے الگ ہدف آئٹم بنائیں۔",
  "/events/avatar-reward یا https://...",
  "کم از کم 8 حروف درج کریں",
  "BB اکائی میں حد۔ حد نہ رکھنے کے لیے 0 درج کریں۔",
  "Event Fee % صفر سے 100 کے درمیان ہونا چاہیے۔",
  "Rake % صفر سے 100 کے درمیان ہونا چاہیے۔",
  "Rake Cap BB صفر یا اس سے زیادہ ہونا چاہیے۔",
  "Redis ای میل قطار",
  "SMTP ناکامیاں دوبارہ آزمائیں",
  "[اختیاری]",
  "[لازمی]",
  "all / ڈیسک ٹاپ + موبائل",
  "all / تمام زبانیں",
  "desktop / ڈیسک ٹاپ",
  "ko / کوریائی",
  "صرف lv2 ایجنٹ اکاؤنٹ میں",
  "lv2 ریفرل انعامی پوائنٹس",
  "mobile / موبائل",
  "تمام {amount} USDT کو اثاثوں میں تبدیل کریں",
  "کیا تمام {amount} USDT پوائنٹس کو موجودہ ایجنٹ کے اثاثوں میں تبدیل کرنا ہے؟",
  "جمع کیے جائیں گے۔ ہر صارف پر صرف ایک بار مہر لگے گی۔",
  "کوئی رجسٹرڈ صارف نہیں ہے۔",
  "رجسٹریشن کی حالت لوڈ نہیں ہو سکی۔",
  "رجسٹریشن کے بعد منظوری کی حالت دیکھی جا سکتی ہے۔",
  "رجسٹریشن کی تاریخ",
  "ہر خانہ ایک الگ معلوماتی بٹن آئٹم ہے۔ موجود نہ ہو تو موجودہ ترتیبات کی نقل بنا کر تخلیق ہوگا؛ موجود ہو تو اسے کھول کر پس منظر الگ تبدیل کیا جا سکتا ہے۔",
  "انفرادی ارسال دستیاب",
  "انفرادی ارسال کے نتائج لوڈ ہو رہے ہیں...",
  "انفرادی ارسال کا کوئی ریکارڈ نہیں۔",
  "انفرادی ارسال کی تاریخ لوڈ نہیں ہو سکی۔",
  "ذاتی معلومات جمع کرنے اور استعمال کرنے کی رضامندی",
  "ذاتی معلومات کے جمع اور استعمال کی اطلاع",
  "رازداری کی اطلاع",
  "تلاش کا کوئی نتیجہ نہیں۔",
  "تلاش جاری ہے",
  "اکاؤنٹ کے مسئلے کے لیے اعلیٰ منتظم سے رابطہ کریں",
  "اکاؤنٹ کی حالت اور رسائی کی اجازتیں چیک کریں۔",
  "اکاؤنٹ بنانے سے پہلے اس کی قسم اور لازمی معلومات چیک کریں۔ نیا اکاؤنٹ فوراً موجودہ ایجنٹ کے تحت منسلک ہو جائے گا۔",
  "اکاؤنٹ کی معلومات",
  "اکاؤنٹ کی تصدیق اور بحالی کے لیے استعمال ہوتا ہے۔",
  "اکاؤنٹ اور بحالی کی معلومات درست درج کریں۔",
  "اکاؤنٹ مالک یا مجاز شخص ہی بنائے۔ اکاؤنٹ شیئر کرنا، اجازت کا غلط استعمال اور سروس میں خلل محدود کیا جا سکتا ہے۔",
  "مشترکہ ڈیوائس پر لاگ اِن برقرار رکھنے کا انتخاب نہ کریں۔",
  "انتظامی ٹولز کھولیں",
  "انتظامی سروس کے لیے",
  "یہ نام انتظامی اسکرین پر دکھایا جائے گا۔",
  "منتظم اکاؤنٹ کی معلومات درج کریں۔",
  "منتظم لاگ اِن کی اطلاع",
  "منتظم مینو",
  "منتظم مینو کھولیں",
  "منتظم کی منظوری",
  "صرف منتظم سے منظور شدہ اکاؤنٹس رسائی حاصل کر سکتے ہیں۔",
  "منظوری درکار اکاؤنٹس منظوری مکمل ہونے کے بعد لاگ اِن کر سکتے ہیں۔",
  "منتظم ID درج کریں",
  "منتظم لاگ اِن",
  "منتظم ہوم",
  "اجازت کی جانچ",
  "موجودہ",
  "موجودہ ہدف آئٹم کھولیں",
  "میرا اکاؤنٹ",
  "اندرونی پاپ اپ URL",
  "نمائش کا ہدف / الگ پس منظر",
  "کل حاصل شدہ پوائنٹس",
  "2 سے 16 حروف کا عرفی نام درج کریں۔",
  "اگلے 20 USDT تک",
  "اگلے انعام کے منتظر صارفین",
  "زیرِ انتظار",
  "قطار",
  "قطار میں شامل کیا جا رہا ہے...",
  "ہدف",
  "حروف کے کیس سمیت بالکل درست درج کریں۔",
  "ڈیسک ٹاپ",
  "وہی پاس ورڈ دوبارہ درج کریں۔",
  "کوئی رجسٹرڈ ای میل نہیں",
  "ڈیوائس",
  "ڈیوائس/زبان کے مطابق فوری پس منظر انتظام",
  "حفاظت کے لیے لاگ اِن اور اہم انتظامی سرگرمیاں ریکارڈ کی جاتی ہیں۔",
  "لاگ اِن ID یاد رکھیں",
  "لاگ اِن ہو رہا ہے…",
  "لاگ اِن پر واپس جائیں",
  "لاگ اِن اسکرین پر جائیں",
  "یہ لاگ اِن کے لیے استعمال ہونے والی ID ہے۔",
  "بار بار ناکام لاگ اِن سے اکاؤنٹ عارضی طور پر لاک ہو سکتا ہے۔ منتظم سے حالت چیک کروائیں۔",
  "درج کریں",
  "لنک کاپی کریں",
  "مارکیٹنگ کی رضامندی",
  "مارکیٹنگ سے رضامند {count} صارفین",
  "مارکیٹنگ ای میل سے رضامند کوئی صارف نہیں۔",
  "ای میل لکھیں",
  "ای میل کا موضوع",
  "ای میل کا موضوع اور متن درج کریں۔",
  "صارف فی",
  "موبائل",
  "تخلیق نہیں ہوا",
  "مشن انعام کے مستفید کی ترتیبات",
  "غیر تصدیق شدہ",
  "ان باکس میں دکھایا جانے والا موضوع",
  "جاری کردہ منتظم اکاؤنٹ ID درج کریں۔",
  "جاری کردہ منتظم ID درج کریں۔",
  "وصول کنندگان",
  "ارسال کا پیش منظر",
  "ارسال کی تاریخ",
  "بھیجنے والا مواد درج کریں۔",
  "بھیجنے کے لیے صارف منتخب کریں۔",
  "کوئی پس منظر نہیں",
  "پس منظر تصویر اپ لوڈ / URL",
  "پس منظر تصویر اپ لوڈ ناکام (سرور اپ لوڈ API چیک کریں)",
  "5 MB یا اس سے کم کی پس منظر تصویر اپ لوڈ کریں۔",
  "بیچ",
  "بٹن URL",
  "بٹن کا متن",
  "تبدیل کریں",
  "تبدیلی جاری ہے...",
  "تبدیلی کے بعد اثاثے",
  "دیکھیں",
  "حفاظتی اطلاع",
  "محفوظ رکھنے کی مدت",
  "محفوظ",
  "یہ ای میل Night Poker Club کی جانب سے بھیجی گئی ہے۔",
  "متن کا عنوان",
  "تقسیم کا فارمولا",
  "فارمولا agent_id:percent کی صورت میں ہو اور percent کا مجموعہ 1 یا 100 ہو۔ مثال: 1002:0.7 / 1001:0.3",
  "پاس ورڈ دوبارہ درج کریں",
  "پاس ورڈ درج کریں",
  "پاس ورڈ کی تصدیق کریں",
  "پاس ورڈ کی تصدیق مطابقت نہیں رکھتی۔",
  "کم از کم 8 حروف کا پاس ورڈ درج کریں۔",
  "دوسری سروسز سے مختلف پاس ورڈ رکھیں۔",
  "ای میل موضوع استعمال کرنے کے لیے خالی چھوڑیں",
  "دستیاب پوائنٹس",
  "درست ای میل پتہ درج کریں۔",
  "انعام کا مستفید",
  "بالائی ایجنٹ: {id}",
  "بالائی ایجنٹ مکمل رقم لے گا",
  "نیا اکاؤنٹ بنائیں۔",
  "سروس کے استعمال کے لیے بنیادی معلومات درج کریں۔",
  "منتخب کریں",
  "کامیاب",
  "منسلک ایجنٹ",
  "رضامندی دی گئی",
  "رضامندی نہیں دی گئی",
  "وصول کنندہ",
  "جمع کی جانے والی معلومات",
  "مستفید ہونے کا طریقہ",
  "مستفید agent_id",
  "مستفید agent_id درج کریں۔",
  "مستفید کی ترتیبات محفوظ نہیں ہو سکیں",
  "صرف سپر ایڈمن · ای میل ورکر قطار سے ارسال",
  "مہر",
  "مہر مکمل",
  "مہر شدہ صارفین",
  "منظور شدہ اکاؤنٹ چیک کریں",
  "صرف منظور شدہ منتظم اکاؤنٹس",
  "آپریشن ڈیش بورڈ اور انتظامی فیچرز کے لیے منظور شدہ منتظم اکاؤنٹ سے لاگ اِن کریں۔",
  "منظور شدہ دائرے میں آپریشن فیچرز استعمال کریں۔",
  "کوشش",
  "اصل ورکر ٹیمپلیٹ کی بنیاد پر",
  "نیچے دیا گیا لنک کاپی کریں۔",
  "اوتار انعامی ایونٹ پاپ اپ URL لاگو کریں",
  "اوتار انعامی ایونٹ پاپ اپ کھولنے کے لیے منزل URL میں یہ درج کریں:",
  "ID",
  "ID، عرفی نام اور پاس ورڈ لازمی ہیں۔ ثانوی پاس ورڈ صرف ضرورت پر درج کریں۔",
  "ID، عرفی نام، ای میل، پاس ورڈ",
  "انگریزی حروف، اعداد اور انڈر اسکور سے 4–20 حروف درج کریں۔",
  "ابھی اکاؤنٹ نہیں ہے؟",
  "ابھی ارسال کی کوئی تاریخ نہیں۔",
  "ابھی تبدیلی کی کوئی تاریخ نہیں۔",
  "ابھی جمع ہونے کی کوئی تاریخ نہیں۔",
  "محفوظ انتظامی سروس",
  "شرائط کی رضامندی",
  "کو یہ پیغام بھیجا جائے گا۔",
  "ایجنٹ رجسٹریشن کی حالت",
  "ایجنٹ درجہ بندی، منسلک صارفین، فیس، اثاثے اور مشن انعام کی پالیسیاں منظم کریں۔",
  "ایجنٹ فہرست لوڈ نہیں ہو سکی۔",
  "اضافی ایجنٹ انعام ادا نہ کریں",
  "ایجنٹ کوڈ",
  "کئی ایجنٹس میں تقسیم کریں",
  "حروف، اعداد اور خصوصی علامات کا مجموعہ تجویز کیا جاتا ہے۔",
  "4–20 حروف اور اعداد",
  "مثال: ویب سائٹ کھولیں",
  "متوقع ارسال",
  "آج کی تنظیمی رجسٹریشن",
  "بہت زیادہ درخواستیں ہیں۔ بعد میں دوبارہ کوشش کریں۔",
  "ترجیح",
  "صارف تلاش",
  "صارف تلاش ناکام ہوئی۔",
  "صارف کوڈ",
  "صارف کوڈ، ID، عرفی نام",
  "صارف کوڈ، ID، عرفی نام یا منسلک ایجنٹ تلاش کریں",
  "یہ ترتیب صارف ٹیبل انعام کو نہیں بدلتی؛ یہ صرف agent_share سے حساب کردہ اضافی انعام کے مستفید طے کرتی ہے۔",
  "ای میل",
  "ای میل انتظام کی معلومات لوڈ ہو رہی ہیں...",
  "ای میل انتظام کی معلومات لوڈ نہیں ہو سکیں۔",
  "ای میل مارکیٹنگ معلومات وصول کریں",
  "ای میل بھیجیں",
  "ای میل ارسال کی درخواست ناکام ہوئی۔",
  "ای میل موضوع کا پیش منظر",
  "یہ ای میل بھیجیں؟\n\nہدف: {target}\nموضوع: {subject}\nمتوقع ارسال: {count}",
  "ای میل ارسال کی قطار میں شامل کر دی گئی ہے۔",
  "کیا پہلے سے اکاؤنٹ ہے؟",
  "یہ ای میل پہلے سے رجسٹرڈ ہے۔",
  "یہ ID پہلے سے استعمال میں ہے۔",
  "استعمال کا مقصد",
  "سروس کی شرائط سے اتفاق",
  "سروس کی شرائط کی رضامندی",
  "سروس کی شرائط اور ذاتی معلومات کے جمع و استعمال سے اتفاق کریں۔",
  "تصدیق شدہ ای میل موجود",
  "تصدیق شدہ ای میل کے بغیر صارف کو نہیں بھیج سکتے۔",
  "تصدیق شدہ ای میل والے، مارکیٹنگ سے رضامند اور بلاک نہ کیے گئے صارفین",
  "تصدیق شدہ",
  "تاریخ اور وقت",
  "درج معلومات صرف اکاؤنٹ بنانے، منظوری، شناخت کی تصدیق اور بحالی کے لیے استعمال ہوتی ہیں۔ اکاؤنٹ بند ہونے یا مقصد مکمل ہونے پر قانونی مدت کے سوا حذف کر دی جاتی ہیں۔",
  "اپنے براہِ راست صارفین اور تمام ذیلی ایجنٹس کے صارفین کا مشترکہ کل دیکھیں۔",
  "اثاثہ تبدیلی مکمل",
  "آپ کا لکھا ہوا ای میل متن یہاں دکھے گا۔",
  "دوبارہ کوشش کے انتظار میں",
  "جمع",
  "جمع کیا جائے گا۔",
  "مخصوص رجسٹریشن URL",
  "سب سے اتفاق",
  "تمام ارسال اہداف",
  "رسائی لاگ کی حفاظت",
  "رسائی شروع کریں۔",
  "معلومات درج کریں",
  "پوری تنظیم",
  "تنظیم کی کل رجسٹریشن",
  "دیکھنے کے لیے ایجنٹ",
  "براہِ راست",
  "براہِ راست رجسٹریشن",
  "براہِ راست ایجنٹ مکمل رقم لے گا",
  "پروسیسنگ وقت / خرابی",
  "گزشتہ 30 دن",
  "گزشتہ 7 دن",
  "حالیہ اثاثہ تبدیلیاں",
  "حالیہ پوائنٹ جمع",
  "اعلیٰ ترین ایجنٹ مکمل رقم لے گا",
  "ہر تنظیم کے ریفرل صارف انعامی پوائنٹس جمع کیے جاتے ہیں",
  "ریفرل کوڈ",
  "ریفرل کوڈ یا ایجنٹ لائن کوڈ",
  "ریفرل کوڈ کی تصدیق نہیں ہو سکی۔",
  "ہدف کے لیے معلوماتی بٹن نہیں بن سکا",
  "ٹیسٹ وصول کنندہ ای میل",
  "ٹیسٹ وصول کنندہ ای میل درج کریں۔",
  "ٹیبل گروپ تصفیہ پالیسی",
  "ٹیبل گروپ تصفیہ پالیسی محفوظ نہیں ہو سکی",
  "مخصوص ایجنٹ مکمل رقم لے گا",
  "پوائنٹ مہر",
  "پوائنٹس کو اثاثوں میں تبدیل کرنا ناکام ہوا۔",
  "پوائنٹس کی حالت دیکھی جا سکتی ہے، مگر صرف متعلقہ lv2 ایجنٹ ہی انہیں اثاثوں میں تبدیل کر سکتا ہے۔",
  "پوائنٹس اثاثوں میں تبدیل کر دیے گئے ہیں۔",
  "دکھایا جانے والا عرفی نام",
  "لازمی ذاتی معلومات کے جمع کرنے کی رضامندی نہ دینے پر رجسٹریشن محدود ہوگی۔",
  "تمام لازمی اور اختیاری نکات سے اتفاق۔",
  "لازمی شرائط اور رازداری کی اطلاع دیکھیں۔",
  "لازمی معلومات درج کریں، ذاتی معلومات کے جمع و استعمال کی اطلاع دیکھیں اور رجسٹریشن مکمل کریں۔",
  "لازمی تصدیق",
  "فٹر اطلاع",
  "ذیلی",
  "ذیلی رجسٹریشن",
  "ذیلی تنظیم کے صارفین",
  "ذیلی ایجنٹ یا عام صارف اکاؤنٹ بنائیں۔ درج معلومات تخلیق کے فوراً بعد لاگو ہوں گی۔",
  "ہر لائن میں ایک agent_id:percent درج کریں۔ percent کا مجموعہ 1 یا 100 ہونا چاہیے۔",
  "انفرادی ارسال کے نتائج دیکھنے کے لیے آئٹم منتخب کریں۔",
  "اس وقت ارسال کے انتظار میں",
  "یہ ریفرل کوڈ فی الحال دستیاب نہیں۔",
  "موجودہ ترتیبات سے ہدف آئٹم بنائیں",
  "موجودہ ایجنٹ کے تحت عام صارف بنائیں۔",
  "موجودہ تدوین:",
  "رجسٹریشن فی الحال معطل ہے۔",
  "فعال",
  "رکن کی شناخت، اکاؤنٹ انتظام، شناخت کی تصدیق اور اکاؤنٹ بحالی",
  "رکن کی شناخت اور اکاؤنٹ انتظام/بحالی کے لیے ہم ID، عرفی نام، ای میل اور تصدیقی معلومات استعمال کرتے ہیں اور مقصد پورا ہونے پر قانون کے مطابق محفوظ یا حذف کرتے ہیں۔",
  "اکاؤنٹ بند ہونے تک یا قانون کی مقررہ مدت تک",
  "رجسٹر کریں",
  "رجسٹریشن API نہیں ملا۔",
  "رجسٹریشن لنک کاپی ہو گیا۔",
  "رجسٹریشن اور اکاؤنٹ انتظام کے لیے ہم درج ذیل ذاتی معلومات جمع کرتے ہیں۔ آگے بڑھنے سے پہلے اسے پڑھیں۔",
  "رجسٹریشن کی اطلاع",
  "رجسٹریشن کی درخواست پر کارروائی نہیں ہو سکی۔",
  "رجسٹریشن کی درخواست مسترد ہو گئی۔",
  "رجسٹریشن مکمل ہو گئی ہے۔ آپ فوراً لاگ اِن کر سکتے ہیں۔",
  "رجسٹریشن کی درخواست مکمل ہو گئی۔ منظور شدہ اکاؤنٹس فوراً لاگ اِن کر سکتے ہیں۔",
  "رجسٹریشن پر کارروائی جاری ہے…"
];

const makeTable = (values) => Object.fromEntries(keys.map((key, index) => [key, values[index]]));

const uiCompletion = {
  ko: makeTable(keys),
  en: makeTable(enValues),
  ru: makeTable(ruValues),
  zh: makeTable(zhValues),
  vi: makeTable(viValues),
  th: makeTable(thValues),
  ja: makeTable(jaValues),
  it: makeTable(itValues),
  fr: makeTable(frValues),
  hi: makeTable(hiValues),
  ur: makeTable(urValues),
};

const dynamicCompletion = {
  ko: {
    '대상 등록 중': '대상 등록 중',
    '발송 대기': '발송 대기',
    '발송 중': '발송 중',
    '일부 실패': '일부 실패',
    '테스트 발송': '테스트 발송',
    '개별 유저': '개별 유저',
    '수신 동의 전체': '수신 동의 전체',
  },
  en: {
    '대상 등록 중': 'Registering recipients',
    '발송 대기': 'Queued',
    '발송 중': 'Sending',
    '일부 실패': 'Partially failed',
    '테스트 발송': 'Test send',
    '개별 유저': 'Individual user',
    '수신 동의 전체': 'All consented users',
  },
  ru: {
    '대상 등록 중': 'Регистрация получателей',
    '발송 대기': 'В очереди',
    '발송 중': 'Отправляется',
    '일부 실패': 'Частично не выполнено',
    '테스트 발송': 'Тестовая отправка',
    '개별 유저': 'Отдельный пользователь',
    '수신 동의 전체': 'Все согласившиеся пользователи',
  },
  zh: {
    '대상 등록 중': '正在登记收件人',
    '발송 대기': '等待发送',
    '발송 중': '发送中',
    '일부 실패': '部分失败',
    '테스트 발송': '测试发送',
    '개별 유저': '单个用户',
    '수신 동의 전체': '全部已同意用户',
  },
  vi: {
    '대상 등록 중': 'Đang đăng ký người nhận',
    '발송 대기': 'Chờ gửi',
    '발송 중': 'Đang gửi',
    '일부 실패': 'Thất bại một phần',
    '테스트 발송': 'Gửi thử',
    '개별 유저': 'Người dùng riêng lẻ',
    '수신 동의 전체': 'Tất cả người dùng đã đồng ý',
  },
  th: {
    '대상 등록 중': 'กำลังลงทะเบียนผู้รับ',
    '발송 대기': 'รอส่ง',
    '발송 중': 'กำลังส่ง',
    '일부 실패': 'ล้มเหลวบางส่วน',
    '테스트 발송': 'ส่งทดสอบ',
    '개별 유저': 'ผู้ใช้รายบุคคล',
    '수신 동의 전체': 'ผู้ใช้ที่ยินยอมทั้งหมด',
  },
  ja: {
    '대상 등록 중': '受信者を登録中',
    '발송 대기': '送信待ち',
    '발송 중': '送信中',
    '일부 실패': '一部失敗',
    '테스트 발송': 'テスト送信',
    '개별 유저': '個別ユーザー',
    '수신 동의 전체': '同意済みユーザー全員',
  },
  it: {
    '대상 등록 중': 'Registrazione destinatari',
    '발송 대기': 'In coda',
    '발송 중': 'Invio in corso',
    '일부 실패': 'Parzialmente non riuscito',
    '테스트 발송': 'Invio di prova',
    '개별 유저': 'Utente individuale',
    '수신 동의 전체': 'Tutti gli utenti consenzienti',
  },
  fr: {
    '대상 등록 중': 'Enregistrement des destinataires',
    '발송 대기': 'En attente d’envoi',
    '발송 중': 'Envoi en cours',
    '일부 실패': 'Échec partiel',
    '테스트 발송': 'Envoi de test',
    '개별 유저': 'Utilisateur individuel',
    '수신 동의 전체': 'Tous les utilisateurs consentants',
  },
  hi: {
    '대상 등록 중': 'प्राप्तकर्ता दर्ज हो रहे हैं',
    '발송 대기': 'भेजने की प्रतीक्षा',
    '발송 중': 'भेजा जा रहा है',
    '일부 실패': 'आंशिक विफलता',
    '테스트 발송': 'परीक्षण भेजना',
    '개별 유저': 'व्यक्तिगत उपयोगकर्ता',
    '수신 동의 전체': 'सभी सहमत उपयोगकर्ता',
  },
  ur: {
    '대상 등록 중': 'وصول کنندگان درج ہو رہے ہیں',
    '발송 대기': 'ارسال کے انتظار میں',
    '발송 중': 'ارسال جاری ہے',
    '일부 실패': 'جزوی ناکامی',
    '테스트 발송': 'آزمائشی ارسال',
    '개별 유저': 'انفرادی صارف',
    '수신 동의 전체': 'تمام رضامند صارفین',
  },
};

Object.entries(dynamicCompletion).forEach(([lang, table]) => {
  Object.assign(uiCompletion[lang], table);
});

export default uiCompletion;
